{
  "admin.roles.title": "Permissions & roles",
  "settings.sectionAccessManagement": "Access management",
  "admin.access.intro": "Who can do what? Permissions define the available actions. Roles bundle those permissions. Only an assignment makes them effective for people.",
  "admin.access.permissionTitle": "Permission · What is allowed?",
  "admin.access.permissionBody": "An action defined by the system, such as reading or editing people. Use the existing permission catalog here.",
  "admin.access.roleTitle": "Role · What belongs together?",
  "admin.access.roleBody": "A named bundle of permissions. You can assemble your own roles. Creating a role alone does not give anyone additional access.",
  "admin.access.assignmentTitle": "Role assignment · For whom and where?",
  "admin.access.assignmentBody": "A role and a scope are assigned to a person circle (segment). Its members receive the included permissions within that scope.",
  "admin.access.rolesBody": "Inspect existing roles and their permissions or create your own role. You can edit and delete unused custom roles. System roles and roles already in use are protected.",
  "admin.access.openRoles": "Open permissions & roles",
  "admin.access.assignmentOutlook": "Role assignments will be the next area. You can already inspect existing assignments on each role, but cannot change them here yet.",
  "admin.access.featureBoundary": "Continue to show or hide Spark areas and features through the feature whitelist. Individual content is shared at the content itself.",
  "admin.roles.new": "Create new role",
  "admin.roles.systemRoles": "System roles",
  "admin.roles.customRoles": "Custom roles",
  "admin.roles.permissions": "Permissions",
  "admin.roles.listTitle": "Roles",
  "admin.roles.addRole": "+ New role",
  "admin.roles.resumeDraft": "Resume draft",
  "admin.roles.details": "Role details",
  "admin.roles.readOnly": "Read-only",
  "admin.roles.edit": "Edit role",
  "admin.roles.delete": "Delete role",
  "admin.roles.deleting": "Deleting …",
  "admin.roles.deleteConfirm": "Permanently delete “{name}”? No Grant references this role. The permission catalog is kept.",
  "admin.roles.systemProtected": "This role is provided by the system. Its name and permissions are fixed; it cannot be edited or deleted here.",
  "admin.roles.inUseProtected": "A Grant already references this role. Editing and deletion are currently locked to keep existing access unchanged.",
  "admin.roles.assignments": "Assignments",
  "admin.roles.membersIn": "People in {name}",
  "admin.roles.membersLoading": "Loading people …",
  "admin.roles.noMembers": "No stored members found.",
  "admin.roles.unnamedPerson": "Unnamed person",
  "admin.roles.retry": "Try again",
  "admin.roles.peopleCount": "{count, plural, one {# person} other {# people}}",
  "admin.roles.noAssignments": "Not assigned to a person circle yet.",
  "admin.roles.noSegment": "No person circle assigned",
  "admin.roles.grantOnly": "Grant prepared",
  "admin.roles.scope": "Scope: {name}",
  "admin.roles.assignmentsHint": "This role applies through these person circles. The total counts each stored member once. Assignments cannot be changed here yet.",
  "admin.roles.shown": "{shown} of {total} permissions",
  "admin.roles.noRoleResults": "No permissions found for this view.",
  "admin.roles.descriptionPlaceholder": "What is this role for?",
  "admin.roles.noResults": "No matching permissions. Your selection is preserved.",
  "admin.roles.clearSearch": "Clear search",
  "admin.roles.intro": "A role bundles permissions for a task. View existing roles and create your own bundles here.",
  "admin.roles.name": "Role name",
  "admin.roles.namePlaceholder": "e.g. HR profile management",
  "admin.roles.description": "Description (optional)",
  "admin.roles.assignPermissions": "What can this role do?",
  "admin.roles.search": "Search permissions",
  "admin.roles.selected": "{count, plural, one {# permission selected} other {# permissions selected}}",
  "admin.roles.unassigned": "People receive this role through a later assignment.",
  "admin.roles.invalidFields": "Enter a role name (up to 120 characters) and keep the description within 2,000 characters.",
  "admin.roles.permissionsRequired": "Select at least one available permission before saving.",
  "admin.roles.loading": "Loading roles and permissions…",
  "admin.roles.created": "Role created. Its assigned permissions have been saved.",
  "admin.roles.existing": "Existing roles",
  "admin.roles.empty": "No roles yet. Create a role with the permissions it needs.",
  "account.label": "Account",
  "admin.accessConfig.audienceAnonymousBody": "Any unregistered visitor. Currently theoretical: spark requires login before anyone reaches a gated route at all.",
  "admin.accessConfig.audienceExternalBody": "Registered but not internal people, e.g. external applicants.",
  "admin.accessConfig.audienceInfoLabel": "Who is {audience}?",
  "admin.accessConfig.audienceInternalBody": "Logged-in employees of your organisation.",
  "admin.accessConfig.belowFloorHint": "Below this feature's minimum audience, refused by the server.",
  "admin.accessConfig.belowFloorLabel": "{label} (below the feature's minimum audience)",
  "admin.accessConfig.collapseGroupLabel": "Collapse {feature}",
  "admin.accessConfig.expandGroupLabel": "Expand {feature}",
  "admin.accessConfig.feature": "Feature",
  "admin.accessConfig.featureLabel.powersSource": "Powers source",
  "admin.accessConfig.featuresIntro": "Which audiences reach which feature. Additive only: an empty row hides the feature from everyone.",
  "admin.accessConfig.featuresTitle": "Feature whitelist",
  "admin.accessConfig.requiresParentHint": "Requires {parent} enabled for this audience first.",
  "admin.accessConfig.requiresParentLabel": "{label} (requires {parent} enabled for this audience first)",
  "admin.accessConfig.toggleLabel": "{feature} for {audience}",
  "admin.accessConfig.uiOnlyBadgeHint": "No server-side guard exists for this feature. Toggling it here only shows or hides the navigation entry in spark; genesis does not refuse the underlying data. An interim measure until this feature gets its own server-side enforcement.",
  "admin.accessConfig.uiOnlyBadgeLabel": "spark-side",
  "admin.addAnswer": "Answer",
  "admin.addQuestion": "Add question",
  "admin.addToGroupLabel": "Add questionnaire",
  "admin.addToGroupPlaceholder": "Select questionnaire",
  "admin.answerPlaceholder": "Answer option",
  "admin.applyPosition": "Apply",
  "admin.assignmentImmediateHint": "Changes here take effect immediately, independently of Save.",
  "admin.changesSaved": "Changes saved.",
  "admin.collapseList": "Collapse list",
  "admin.confirmDeleteQ": "Delete questionnaire?",
  "admin.confirmRemoveFromGroup": "Remove from the group? It loses its position, and its answers stop counting towards this group's evaluation.",
  "admin.defaultPowerLabel": "Default power (optional)",
  "admin.deleteGroup": "Delete group",
  "admin.deleteGroupMessage": "Deletes the group only. {count, plural, =0 {It holds no questionnaires.} one {Its # questionnaire stays and loses its group and its position.} other {Its # questionnaires stay and lose their group and their position.}} Answers already given are untouched.",
  "admin.deleteGroupTitle": "Delete “{name}”?",
  "admin.expandListNamed": "Show {title}",
  "admin.groupAssignmentTitle": "Assignment",
  "admin.groupDescriptionDeLabel": "Description (German)",
  "admin.groupDescriptionEnLabel": "Description (English)",
  "admin.groupDescriptionHint": "Read first on the catalogue tile and above the group in Grow. The tile clamps it, so aim for about {max} characters.",
  "admin.groupImageAlt": "Tile image of the group",
  "admin.groupImageDrop": "Drag an image here or click to upload",
  "admin.groupImageHint": "About 16:10, one flat motif, no text and no fine detail. The tile shows it small and sharp.",
  "admin.groupImageLabel": "Tile image",
  "admin.groupImageLimit": "Max. {max} MB, PNG, JPEG, GIF, BMP, TIFF or WebP",
  "admin.groupImageRemove": "Remove image",
  "admin.groupImageRemoveConfirm": "Remove image? The tile falls back to the generated artwork.",
  "admin.groupImageReplace": "Replace",
  "admin.groupImageTooLarge": "Too large (max. {max} MB): {name}",
  "admin.groupImageUnsupported": "Unsupported file type: {name}",
  "admin.groupItemCount": "{count, plural, one {# question} other {# questions}}",
  "admin.groupLabel": "Group",
  "admin.groupMembersTitle": "Questionnaires in this group",
  "admin.groupNameDeLabel": "Name (German)",
  "admin.groupNameEnLabel": "Name (English)",
  "admin.groupNamePlaceholder": "e.g. Power Quiz",
  "admin.groupNoMembers": "No questionnaire assigned yet.",
  "admin.groupPositionHint": "Where the group itself sits in Grow · Play.",
  "admin.groupPositionLabel": "Position in Grow · Play",
  "admin.groupValidationHint": "A name in German and English is required.",
  "admin.inGroupOption": "{name} (in {group})",
  "admin.instructionsLabel": "Instructions (optional)",
  "admin.instructionsPlaceholder": "Hint for the person filling it out",
  "admin.memberPositionLabel": "Position in the group",
  "admin.moveDown": "Move down",
  "admin.moveUp": "Move up",
  "admin.nameLabel": "Name",
  "admin.namePlaceholder": "e.g. Empathy check",
  "admin.newGroup": "+ New group",
  "admin.newGroupTitle": "New group",
  "admin.newQuestionnaire": "+ New questionnaire",
  "admin.noQuestionnaires": "No questionnaires yet.",
  "admin.nonePlaceholder": "None",
  "admin.notVisibleInGrow": "Not in the Grow play catalogue.",
  "admin.publishAnyway": "Publish anyway",
  "admin.publishEmptyMessage": "This group has no active questionnaire, so publishing it still gives the catalogue no tile to show.",
  "admin.publishEmptyTitle": "Publish without an active questionnaire?",
  "admin.publishGroup": "Publish",
  "admin.qTitle": "Questionnaires",
  "admin.questionPlaceholder": "Question / statement",
  "admin.referenceData.saveFailed": "The entry could not be saved.",
  "admin.rehomeConfirm": "Move",
  "admin.rehomeFromMessage": "“{name}” moves out of “{from}” and into “{to}”, at the end of the order. Answers already given move with it and count towards the evaluation of “{to}” from now on.",
  "admin.rehomeMessage": "“{name}” is placed at the end of “{to}”. Answers already given count towards the evaluation of “{to}” from now on.",
  "admin.rehomeTitle": "Move “{name}”?",
  "admin.removeAnswer": "Remove answer",
  "admin.removeQuestion": "Remove question",
  "admin.selectOrCreate": "Select a group or questionnaire on the left, or create a new one.",
  "admin.selectPower": "Select power",
  "admin.selectionGone": "This entry no longer exists. Pick another one on the left.",
  "admin.statusActive": "Active",
  "admin.statusDeleted": "Deleted",
  "admin.statusDraft": "Draft",
  "admin.statusInactive": "Inactive",
  "admin.statusLabel": "Status",
  "admin.statusPublished": "Published",
  "admin.toggleGroupCollapsed": "{state, select, collapsed {Expand} other {Collapse}} {name}",
  "admin.ungroupMessage": "“{name}” leaves “{from}” and loses its position. Its answers no longer count towards the evaluation of “{from}”.",
  "admin.ungroupTitle": "Remove “{name}” from its group?",
  "admin.ungrouped": "Without group",
  "admin.unpublishGroup": "Withdraw",
  "admin.unpublishMessage": "The group leaves the Grow play catalogue. Answers already given stay and keep counting towards the evaluation.",
  "admin.unpublishTitle": "Withdraw “{name}”?",
  "admin.validationHint": "Name, plus text + power per question and text per answer required.",
  "admin.weightLabel": "Weight",
  "admin.yesDelete": "Yes, delete",
  "admin.yesRemove": "Yes, remove",
  "adminSettings.appearance.accentHint": "Accent · Buttons, highlights",
  "adminSettings.appearance.accentLabel": "Accent",
  "adminSettings.appearance.bgHint": "Base · Page",
  "adminSettings.appearance.bgLabel": "Background",
  "adminSettings.appearance.openPicker": "Open colour picker",
  "adminSettings.appearance.presetsFor": "Presets for {label}",
  "adminSettings.appearance.reset": "↺ Reset to default",
  "adminSettings.appearance.sub": "Background, surface and accent drive the app. Text is set to black or white automatically.",
  "adminSettings.appearance.surfaceHint": "Cards · Surfaces",
  "adminSettings.appearance.surfaceLabel": "Boxes",
  "adminSettings.appearance.title": "Palette",
  "adminSettings.branding.appName": "App name",
  "adminSettings.branding.appNameHint": "Shown top-left. Empty falls back to “smycles”.",
  "adminSettings.branding.appNamePlaceholder": "smycles",
  "adminSettings.branding.linkPicker.displayText": "Display text",
  "adminSettings.branding.linkPicker.insert": "Insert",
  "adminSettings.branding.linkPicker.page.growPlay": "Grow · Play",
  "adminSettings.branding.linkPicker.page.home": "Home",
  "adminSettings.branding.linkPicker.page.match": "Match",
  "adminSettings.branding.linkPicker.page.share": "Share",
  "adminSettings.branding.linkPicker.searchPlaceholder": "Search by name …",
  "adminSettings.branding.linkPicker.shareItem": "Specific Share item …",
  "adminSettings.branding.linkPicker.trigger": "Insert link",
  "adminSettings.branding.linkPicker.unnamedShareItem": "Unnamed Share item",
  "adminSettings.branding.paletteNote": "The palette below applies live; unsaved changes appear in the save bar and persist platform-wide on save.",
  "adminSettings.branding.sub": "App name and colour palette. Applies platform-wide.",
  "adminSettings.branding.title": "Branding",
  "adminSettings.emailTemplates.body": "Content",
  "adminSettings.emailTemplates.defaultActive": "The default is currently active.",
  "adminSettings.emailTemplates.empty": "No email templates are available.",
  "adminSettings.emailTemplates.kind.INVITATION": "Invitation",
  "adminSettings.emailTemplates.loading": "Loading…",
  "adminSettings.emailTemplates.placeholderRequired": "{token} (required)",
  "adminSettings.emailTemplates.placeholders": "Available placeholders: {tokens}",
  "adminSettings.emailTemplates.previewApproximationHint": "This preview is approximate. Keycloak and the recipient's email client determine the final appearance.",
  "adminSettings.emailTemplates.previewEmptyBody": "No content.",
  "adminSettings.emailTemplates.previewEmptySubject": "No subject.",
  "adminSettings.emailTemplates.previewLabel": "Email preview",
  "adminSettings.emailTemplates.previewLink": "Individual invitation link",
  "adminSettings.emailTemplates.realmWideHint": "This text applies to all Keycloak action emails in the realm, including credential resets initiated in the Admin Console.",
  "adminSettings.emailTemplates.reset": "Use default",
  "adminSettings.emailTemplates.storageDisabled": "Editing email templates is not enabled on this server. The template is shown read-only.",
  "adminSettings.emailTemplates.storageUnavailable": "The template store is currently unreachable. The template is shown read-only and stored changes may not be visible.",
  "adminSettings.emailTemplates.sub": "Subject and content used for the next system email.",
  "adminSettings.emailTemplates.subject": "Subject",
  "adminSettings.emailTemplates.title": "Email templates",
  "adminSettings.emailTemplates.validation.applicationNameSingleLine": "The app name must contain exactly one line. Change it in system settings.",
  "adminSettings.emailTemplates.validation.bodyTooLong": "Content must not exceed {max} characters after inserting the app name.",
  "adminSettings.emailTemplates.validation.linkInSubject": "The {token} placeholder is not allowed in the subject.",
  "adminSettings.emailTemplates.validation.requiredPlaceholder": "Content must contain the required {token} placeholder.",
  "adminSettings.emailTemplates.validation.reservedSequence": "The template contains an unsupported control sequence.",
  "adminSettings.emailTemplates.validation.subjectSingleLine": "The subject must contain exactly one line.",
  "adminSettings.emailTemplates.validation.subjectTooLong": "The subject must not exceed {max} characters after inserting the app name.",
  "adminSettings.emailTemplates.validation.unknownPlaceholder": "The placeholder {token} is not supported.",
  "adminSettings.emailTemplates.viewEditor": "Editor",
  "adminSettings.emailTemplates.viewLabel": "Template view",
  "adminSettings.emailTemplates.viewPreview": "Preview",
  "adminSettings.branding.welcomeMessage": "Welcome message",
  "adminSettings.branding.welcomeMessageHint": "Supports links: [Text](/path). Everything else is shown as plain text.",
  "adminSettings.branding.welcomeMessagePlaceholder": "Shown as a dismissable hint on the home page.",
  "adminSettings.hrPrompt.defaultActive": "The Genesis default is currently active.",
  "adminSettings.hrPrompt.hint": "The '{{responseLanguage}}' placeholder is replaced automatically. A match supplement comes last in the combined prompt and takes precedence on conflicts.",
  "adminSettings.hrPrompt.label": "Global HR base prompt",
  "adminSettings.hrPrompt.reset": "Use Genesis default",
  "adminSettings.hrPrompt.sub": "Central recruiter instruction for all review matches. Match-specific supplements are appended afterwards.",
  "adminSettings.hrPrompt.title": "HR prompt",
  "agent.back": "Back to chats",
  "agent.chatsEmpty": "No chats yet. Start a new one above.",
  "agent.chatsError": "Couldn't load chats.",
  "agent.chatsLoading": "Loading…",
  "agent.close": "Close",
  "agent.closeImage": "Close image",
  "agent.contextBreak": "New context window",
  "agent.deleteChat": "Delete chat",
  "agent.deleteMessage": "This conversation will be permanently deleted.",
  "agent.deleteTitle": "Delete chat?",
  "agent.empty": "Ask the assistant about people, profiles and more.",
  "agent.attach.button": "Attach a document",
  "agent.attach.cancel": "Cancel",
  "agent.attach.drop": "Drop to attach to this chat",
  "agent.attach.prompt": "Attach “{name}”?",
  "agent.attach.remove": "Remove attachment",
  "agent.attach.status.error": "upload failed",
  "agent.attach.status.failed": "failed",
  "agent.attach.status.pending": "queued",
  "agent.attach.status.processing": "processing…",
  "agent.attach.status.ready": "ready",
  "agent.attach.status.uploading": "uploading…",
  "agent.attach.textOnly": "Upload (text only)",
  "agent.attach.unavailable": "Unavailable for the current model",
  "agent.attach.unavailableHint": "Not embedded for the active model. Remove and upload again to use it.",
  "agent.attach.withImages": "Upload with images",
  "agent.attach.withoutImages": "Upload without images",
  "agent.error": "Couldn't reach the assistant. Try again.",
  "agent.expandImage": "View full size",
  "agent.input": "Assistant input",
  "agent.jumpToLatest": "Jump to latest",
  "agent.newChat": "New chat",
  "agent.personInfo.heading": "Profile",
  "agent.personInfo.label": "Load full profile",
  "agent.placeholder": "Ask the assistant…",
  "agent.send": "Send",
  "agent.starters.growth.0": "What skills should I develop next?",
  "agent.starters.growth.1": "Which roles match my experience?",
  "agent.starters.growth.2": "Where can I grow from here?",
  "agent.starters.growth.3": "What experience am I missing for senior roles?",
  "agent.starters.growth.4": "Suggest a learning path for me",
  "agent.starters.growth.5": "Which skills are most in demand?",
  "agent.starters.growth.6": "What strengths can I build on?",
  "agent.starters.growth.7": "Compare my profile to a target role",
  "agent.starters.growth.8": "What gaps hold me back?",
  "agent.starters.growth.9": "Recommend next steps for my career",
  "agent.starters.match.0": "List my recent matches",
  "agent.starters.match.1": "What search options are there?",
  "agent.starters.match.2": "Show details of my latest match",
  "agent.starters.match.3": "Count my matches",
  "agent.starters.match.4": "Find a match by name",
  "agent.starters.match.5": "Which match did I update last?",
  "agent.starters.match.6": "Search for a person",
  "agent.starters.match.7": "Show my newest match's candidates",
  "agent.starters.match.8": "What can I search for?",
  "agent.starters.match.9": "List matches from this month",
  "agent.starters.save.0": "Show my profile",
  "agent.starters.save.1": "What skills are on my profile?",
  "agent.starters.save.2": "Which languages do I have?",
  "agent.starters.save.3": "What experience is on my profile?",
  "agent.starters.save.4": "Summarize my profile",
  "agent.starters.save.5": "What is my current job title?",
  "agent.starters.save.6": "List my education",
  "agent.starters.save.7": "Which companies have I worked at?",
  "agent.starters.save.8": "What's my strongest skill area?",
  "agent.starters.save.9": "Show my contact details",
  "agent.starters.share.0": "List my shared items",
  "agent.starters.share.1": "Show my most recent share",
  "agent.starters.share.2": "Summarize my shared projects",
  "agent.starters.share.3": "Show my public shares",
  "agent.starters.share.4": "Show my private shares",
  "agent.starters.share.5": "List what I shared this month",
  "agent.starters.share.6": "Show details of my latest share",
  "agent.starters.share.7": "Find a shared item by name",
  "agent.starters.share.8": "List items shared with my team",
  "agent.starters.share.9": "List my shared projects",
  "agent.title": "Assistant",
  "agent.tour.back": "Back",
  "agent.tour.buttonHint.back": "Back: revisit the previous step.",
  "agent.tour.buttonHint.next": "Next: continue right away.",
  "agent.tour.buttonHint.pause": "Pause: halt the tour and ask questions.",
  "agent.tour.buttonHint.skipSection": "Skip section: jump to the next area.",
  "agent.tour.buttonHint.stop": "Stop or Esc: end the tour.",
  "agent.tour.chipHome": "Main page",
  "agent.tour.continue": "Continue",
  "agent.tour.escHint": "_Use the buttons below the chat: back, pause, next and skip section. Press **Esc** or the stop button anytime to end the tour._",
  "agent.tour.finished": "That's the end of the tour. Ask me anything about what you saw!",
  "agent.tour.mobileNotice": "Tours highlight elements on the page next to the chat, so they need a larger screen. Please try it on a desktop window.",
  "agent.tour.modeActive": "Tour mode",
  "agent.tour.modeFinished": "Tour finished. Click a snippet or step back to review; stop exits.",
  "agent.tour.modePaused": "Tour paused. You can ask questions now.",
  "agent.tour.next": "Next",
  "agent.tour.next.heading": "Now try it yourself:",
  "agent.tour.next.linkedin": "Import your data via LinkedIn",
  "agent.tour.next.match": "Create a match",
  "agent.tour.next.profile": "Fill out your profile",
  "agent.tour.next.project": "Create a project",
  "agent.tour.next.quiz": "Take a power quiz",
  "agent.tour.noTour": "There is no tour for this page yet.",
  "agent.tour.pause": "Pause",
  "agent.tour.pillar.grow": "GROW is your power playground: assess your 30 powers, watch learning content and play your way to a sharper profile.",
  "agent.tour.pillar.home": "The Smycles logo always takes you to the main page: your dashboard with the latest numbers from every section.",
  "agent.tour.pillar.match": "MATCH builds teams: you define the requirements, the solver picks the right people.",
  "agent.tour.pillar.save": "SAVE is your personal data vault: your profile, CV entries, documents, contacts and pinboard.",
  "agent.tour.pillar.share": "SHARE is the community feed: publish projects and posts, gather interested people and feedback.",
  "agent.tour.questionContinue": "Show everything",
  "agent.tour.questionFinish": "Finish the tour",
  "agent.tour.sectionQuestion": "Should I show you one section first? Pick it below the chat, otherwise I'll present the main page and every section one after another.",
  "agent.tour.sectionQuestionNext": "That section is done. Should I show you another one? Pick it below the chat, otherwise the tour ends here.",
  "agent.tour.sectionsIntro": "I'll quickly show you the sections before we go into details.",
  "agent.tour.skipSection": "Skip section",
  "agent.tour.starterChip": "Show me around this page",
  "agent.tour.starterChipAll": "Show me around the app",
  "agent.tour.stop": "Stop tour",
  "agent.tour.topbar.assistant": "The AI assistant: this button opens and closes the chat you are reading right now.",
  "agent.tour.topbar.chat": "Messages: direct chats with your contacts.",
  "agent.tour.topbar.notifications": "Notifications: invitations, updates and activity around you land here.",
  "agent.tour.topbar.search": "The global search: find people, projects and posts from anywhere in the app.",
  "agent.tour.topbar.user": "Your account: click your name for the profile menu, settings and logout.",
  "agent.tour.welcome": "Welcome to the Smycles system. This tour presents the important features. The buttons under the chat steer the tour. You can also click any chat snippet to jump back to its spot.",
  "agent.untitled": "Untitled chat",
  "auth.redirecting": "Redirecting to login…",
  "auth.sessionExpired.body": "You have been signed out because the session reached its time limit. Changes are no longer being saved. Sign in again to continue where you left off.",
  "auth.sessionExpired.bodyTokensLost": "You have been signed out. Changes are no longer being saved. Sign in again to continue where you left off.",
  "auth.sessionExpired.signIn": "Sign in again",
  "auth.sessionExpired.title": "Session ended",
  "chat.closeChat": "Close chat",
  "chat.deleteChat": "Delete chat",
  "chat.deleteChatConfirm": "Delete this conversation?",
  "chat.liveUpdatesUnavailable": "Live updates unavailable",
  "chat.messageInput": "Message input",
  "chat.messages": "Messages",
  "chat.minimize": "Minimize",
  "chat.more": "More",
  "chat.newConversation": "New conversation",
  "chat.noConversationsYet": "No conversations yet",
  "chat.online": "Online",
  "chat.openMessages": "Messages",
  "chat.searchChats": "Search chats…",
  "chat.searchEnd": "{count} results",
  "chat.searchHint": "Type at least {n} characters",
  "chat.searchPeople": "Search people…",
  "chat.seen": "Seen",
  "chat.sendMessage": "Send message",
  "chat.typing": "typing…",
  "chat.unreadMessages": "{count} unread",
  "chat.writeMessage": "Write a message…",
  "chat.you": "You",
  "cockpit.dismiss": "Dismiss",
  "cockpit.dismissAll": "Dismiss all",
  "cockpit.dismissAllMessage": "This clears your notification inbox and cannot be undone. Notifications that are still waiting for your answer are kept.",
  "cockpit.dismissAllTitle": "Dismiss all notifications?",
  "cockpit.jobActive": "Active",
  "cockpit.noNotifications": "No notifications",
  "cockpit.notifications": "Notifications",
  "cockpit.showMoreDocuments": "Show {count} more",
  "cockpit.unread": "unread",
  "comments.delete.body": "The comment will be removed for good. This cannot be undone.",
  "comments.delete.title": "Delete comment?",
  "comments.discard.body": "Discard the unsaved changes to this comment?",
  "common.add": "Add",
  "common.back": "Back",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.comingSoon": "Coming soon",
  "common.confirm": "Confirm",
  "common.create": "Create",
  "common.delete": "Delete",
  "common.deleteFailed": "Delete failed.",
  "common.discard": "Discard",
  "common.duplicateName": "An entry with this name already exists. Please choose a different name.",
  "common.edit": "Edit",
  "common.errorWithMessage": "Error: {message}",
  "common.fileDrop.overlay": "Drop to upload …",
  "common.fileDrop.zone": "Drag a file here or click to upload",
  "common.loadMore": "Load more",
  "common.loading": "Loading…",
  "common.loadingMore": "Loading…",
  "common.next": "Next",
  "common.nextPage": "Next",
  "common.noBackend": "No backend endpoint",
  "common.noResults": "No results found",
  "common.notFound": "Not found",
  "common.notFoundBody": "The page you're looking for doesn't exist.",
  "common.pageOf": "Page {page} of {total}",
  "common.prevPage": "Previous",
  "common.remove": "Remove",
  "common.reset": "Reset",
  "common.save": "Save",
  "common.saveFailed": "Save failed.",
  "common.saving": "Saving…",
  "common.serverError": "Something went wrong. Please try again.",
  "common.serverErrorWithCode": "Something went wrong. Please try again. (Code {code})",
  "common.share.ariaActive": "Sharing active",
  "common.share.ariaAllOff": "All private",
  "common.share.ariaAllOn": "Share all",
  "common.share.ariaInactive": "Not sharing",
  "common.share.off": "Private",
  "common.share.on": "Share",
  "common.tryAgain": "Try again",
  "common.undo": "Undo",
  "common.unsavedChanges": "Unsaved changes",
  "community.tour.contacts.desc": "{count} contacts in the current view. Click a card to open the profile, use \"+ Add\" to put it into communities, or drag it onto one on the left.",
  "community.tour.contacts.title": "Your contacts",
  "community.tour.controls.desc": "Search contacts by name, change the sort order, or filter to contacts that are not in any community yet.",
  "community.tour.controls.title": "Search & sort",
  "community.tour.groups.desc": "{count} communities to group your contacts. Click one to see its members, create new ones via \"+ Community\", and drag a contact card onto a community to add it.",
  "community.tour.groups.title": "Your communities",
  "community.tour.label": "Save Community",
  "community.tour.summary": "This is your Community page: {contacts} contacts, organized into {groups} communities.",
  "company.admin.competencies.blank": "An expertise needs a name. Give it one, or remove it.",
  "company.admin.competencies.duplicate": "This company already lists the expertise ‘{label}’.",
  "company.admin.competencies.label": "Expertise",
  "company.admin.competencies.labelPlaceholder": "e.g. Regulatory Affairs",
  "company.admin.competencies.listFull": "This company already lists {max, number} expertise entries, which is the maximum. Remove one to add another.",
  "company.admin.competencies.pendingAddNamed": "‘{label}’ will be added when you save.",
  "company.admin.competencies.pendingEditNamed": "‘{label}’ will be rewritten when you save.",
  "company.admin.competencies.pendingRemoveNamed": "‘{label}’ will be removed when you save.",
  "company.admin.competencies.tooLong": "An expertise can be at most {max, number} characters long.",
  "company.admin.done": "Done editing",
  "company.admin.edit": "Edit company",
  "company.admin.error.alreadyMember": "This person is already listed at this company.",
  "company.admin.error.cannotAdminister": "This person's account is not active, so they cannot administer a company. Choose somebody whose account is still active.",
  "company.admin.error.employeeCount": "The number of employees must be a whole number of 0 or more.",
  "company.admin.error.expertiseAlreadyListed": "“{label}” is already listed, so it cannot be added twice. Remove the existing entry if you want to give it a different level.",
  "company.admin.error.expertiseListFull": "This company already lists {max, number} expertise entries, which is the maximum. Remove one to add another.",
  "company.admin.error.expertiseTooLong": "An expertise can be at most {max, number} characters long. Shorten it and add it again.",
  "company.admin.error.lastAdmin": "A company must keep at least one administrator. Make somebody else an administrator first.",
  "company.admin.error.logoRefused": "The logo was refused. It has to be a PNG, JPEG, GIF, BMP, TIFF or WebP image of at most {max, number} MB.",
  "company.admin.error.nameRequired": "A company name is required.",
  "company.admin.error.nameTooLong": "The company name may be at most {max, number} characters.",
  "company.admin.error.notAdmin": "You no longer administer this company. Reload the page to see what you can still do.",
  "company.admin.error.saveProfile": "The company could not be saved.",
  "company.admin.error.summaryTooLong": "The About us text may be at most {max, number} characters.",
  "company.admin.error.tooManyContactPersons": "A company can have at most {max, number} contact persons. Somebody else has just used the last slot, so unmark one to mark this person.",
  "company.admin.field.employeeCount": "Employees",
  "company.admin.field.industry": "Industry",
  "company.admin.field.industryNoResults": "No industry matches",
  "company.admin.field.industryPlaceholder": "No industry",
  "company.admin.field.industrySearch": "Search industries",
  "company.admin.field.name": "Name",
  "company.admin.field.summary": "About us",
  "company.admin.logo.change": "Change the company logo",
  "company.admin.logo.choose": "Upload a company logo",
  "company.admin.logo.saved": "Logo saved.",
  "company.admin.logo.tooLarge": "{name} is too large. A logo may be at most {max, number} MB.",
  "company.admin.logo.tooManyPixels": "This image is too large to crop. Use one under {max} megapixels.",
  "company.admin.logo.unreadable": "That file could not be read. Try choosing it again.",
  "company.admin.logo.unsupported": "{name} cannot be used as a logo. Choose a PNG, JPEG, GIF, BMP, TIFF or WebP image.",
  "company.admin.members.add": "Add to company",
  "company.admin.members.addHint": "Puts an existing person on the list. They are not asked first, and nothing is written until you save.",
  "company.admin.members.addTitle": "Add a person",
  "company.admin.members.contactPerson": "Contact person",
  "company.admin.members.contactPersonLimit": "All {max, number} contact persons are marked. Unmark one to mark somebody else.",
  "company.admin.members.noPeople": "Nobody matches who is not already listed.",
  "company.admin.members.pendingAdd": "Will be added when you save.",
  "company.admin.members.pendingContact": "The contact-person mark applies when you save.",
  "company.admin.members.pendingRemove": "Will be removed when you save.",
  "company.admin.members.pendingRole": "The new role applies when you save.",
  "company.admin.members.remove": "Remove",
  "company.admin.members.roleAdmin": "Administrator",
  "company.admin.members.roleMember": "Member",
  "company.admin.members.searchPlaceholder": "Search people by name",
  "company.admin.members.searching": "Searching people",
  "company.admin.members.soleAdmin": "The only administrator. Make somebody else an administrator to change or remove this one.",
  "company.admin.profile.saved": "Saved.",
  "company.admin.status.confirm": "Deactivating takes this company out of both searches and freezes its posts and projects: they can no longer be published, edited or deleted. Nothing is deleted, and reactivating gives all of it back.",
  "company.admin.status.deactivate": "Deactivate company",
  "company.admin.status.deactivateConfirm": "Deactivate",
  "company.admin.status.inactive": "This company is deactivated. It is out of both searches, and nothing can be published or changed in its name.",
  "company.admin.status.label": "Company status",
  "company.admin.status.reactivate": "Reactivate company",
  "company.context.acting": "Acting as {name}.",
  "company.context.current": "Acting as this company",
  "company.context.enter": "Act as this company",
  "company.context.enterNamed": "Act as {name}",
  "company.context.landmark": "Company context",
  "company.context.leave": "Leave company context",
  "company.context.scopeAdmin": "You can view and edit this company, manage its people, and publish in its name.",
  "company.context.unsavedBody": "Changing the company context reloads everything on screen. Changes you have not saved will be lost.",
  "company.create.failed": "The company could not be created.",
  "company.create.submit": "Create company",
  "company.inactive.frozen": "This company is inactive, so its posts and projects are frozen. Reactivate the company to publish or change anything in its name.",
  "company.inactive.frozenReader": "This company is inactive, so its posts and projects are frozen.",
  "company.mine.empty": "You are not listed at any company yet. An administrator of a company can add you to it.",
  "company.mine.emptyWithCreate": "You are not listed at any company yet. Register one to get started.",
  "company.mine.intro": "The companies you are listed at. Open one to see its page.",
  "company.mine.loading": "Loading your companies",
  "company.mine.new": "New company",
  "company.mine.title": "My companies",
  "company.page.card.title": "Company card",
  "company.page.competencies.empty": "No competencies recorded yet.",
  "company.page.competencies.noCapability": "No capability",
  "company.page.competencies.title": "Expertise",
  "company.page.about.empty": "This company has not described itself yet.",
  "company.page.about.title": "About us",
  "company.page.contacts.hint": "The people this company named to talk to. Open a profile to get in touch.",
  "company.page.contacts.title": "Contact persons",
  "company.page.employeeCount.unset": "Number",
  "company.page.employeeCount.unit": "{count, plural, one {employee} other {employees}}",
  "company.page.industry.unset": "Industry not specified",
  "company.page.employeeCount": "{count, plural, one {# employee} other {# employees}}",
  "company.page.loading": "Loading company",
  "company.page.members.count": "{count, plural, one {# person} other {# people}}",
  "company.page.members.countPartial": "{shown} of {total} people shown",
  "company.page.members.empty": "Nobody is listed yet.",
  "company.page.members.loadingMore": "Loading people",
  "company.page.members.showMore": "Show more people",
  "company.page.members.title": "People",
  "company.page.stopEditingUnsavedBody": "Leaving edit mode discards everything you have not saved: the profile, the logo, and any people or expertise you added or removed.",
  "company.page.work.title": "Posts and projects",
  "company.page.notFound": "Company not found",
  "company.page.notFoundHint": "This company does not exist or is not visible to you.",
  "company.validation.alreadyExists": "{field} is already taken. Choose a different one.",
  "company.validation.formatError": "{field} has an unexpected value. Check it and save again.",
  "company.validation.isMandatory": "{field} is required.",
  "cv.color": "Color",
  "cv.createFailed": "Creating the CV failed.",
  "cv.createTitle": "Create CV",
  "cv.download": "Download",
  "cv.downloadFailed": "Download failed.",
  "cv.editTitle": "Edit CV",
  "cv.error.nameRequired": "A name is required.",
  "cv.field.address": "Location",
  "cv.field.birthDate": "Date of birth",
  "cv.field.drivingLicence": "Driving licence",
  "cv.field.email": "Email",
  "cv.field.nationality": "Nationality",
  "cv.field.phone": "Phone",
  "cv.field.web": "Web",
  "cv.generator": "CV Generator",
  "cv.name": "Name",
  "cv.notSignedIn": "Not signed in?",
  "cv.personal.born": "b. {date}",
  "cv.personal.licence": "Licence {value}",
  "cv.previewTitle": "CV Preview",
  "cv.reallyDelete": "Really delete",
  "cv.saveCv": "Save CV",
  "cv.section.certifications": "Certifications",
  "cv.section.education": "Education",
  "cv.section.experience": "Work Experience",
  "cv.section.expertise": "Expertise",
  "cv.section.languages": "Languages",
  "cv.section.summary": "Profile",
  "cv.sectionCertifications": "Certificates",
  "cv.sectionEducation": "Education",
  "cv.sectionExperience": "Work experience",
  "cv.sectionExpertise": "Expertise",
  "cv.sectionLanguages": "Languages",
  "cv.sectionProfile": "Profile",
  "cv.sections": "Sections",
  "cv.sidebarContact": "Contact",
  "cv.sliderHeadingSize": "Heading size",
  "cv.sliderIndentation": "Indentation",
  "cv.sliderSectionMargin": "Section margin",
  "cv.sliderSpacing": "Spacing",
  "cv.sliderTextSize": "Text size",
  "cv.template": "Template",
  "cv.template.comic.tagline": "THE BEST RESUME OF ALL TIME!!!",
  "cv.template.contact": "Contact",
  "cv.updateFailed": "Updating the CV failed.",
  "cv.variant": "Variant {n}",
  "design.addEntry": "Add entry",
  "design.apply": "Apply",
  "design.booleanYes": "Yes",
  "design.cardComments": "Comments",
  "design.cardRating": "Rating",
  "design.cardViews": "Views",
  "design.chipCommented": "Commented",
  "design.chipCreated": "Created",
  "design.chipInterested": "Interested",
  "design.chipRated": "Rated",
  "design.chipWatched": "Watched",
  "design.chooseLevel": "Choose level.",
  "design.clearValue": "Clear value",
  "design.copied": "Copied",
  "design.copy": "Copy",
  "design.cropPhoto": "Crop photo",
  "design.filterPlaceholder": "Type to filter …",
  "design.monthPlaceholder": "Month",
  "design.numberStepperDecrease": "Decrease {noun}",
  "design.numberStepperFallbackNoun": "value",
  "design.numberStepperIncrease": "Increase {noun}",
  "design.removeTask": "Remove task",
  "design.requiredField": "Required field",
  "design.selectPlaceholder": "Select …",
  "design.selfAssessmentDone": "Self-assessment completed",
  "design.shareLink": "Share link",
  "design.shareTitle": "Share",
  "design.shareWithArrow": "↗ Share",
  "design.stillFillIn": "Please still fill in: {fields}",
  "design.yearPlaceholder": "Year",
  "design.zoom": "Zoom",
  "documents.nameTooLong": "A document name may be at most 255 characters.",
  "error.route.body": "Something in this view could not be read. Your data is unchanged. You can go back and try another page.",
  "error.route.reload": "Reload the page",
  "error.route.title": "This page could not be displayed",
  "grow.assessment.allAnswered": "All questions answered",
  "grow.assessment.askAria": "Ask the assistant about this statement",
  "grow.assessment.boxAriaLabel": "Go to question {index}",
  "grow.assessment.boxTitle": "Question {index}",
  "grow.assessment.boxTitleAnswered": "Question {index} · answered",
  "grow.assessment.enterToContinue": "Enter to continue",
  "grow.assessment.keyboardHint": "Keys 1–{max} or ←/→ to select",
  "grow.assessment.progress": "Question {index} / {total} · {answered} answered",
  "grow.assessment.saveFailed": "Could not save.",
  "grow.assessment.skip": "Skip",
  "grow.assessment.zoneHint": "↑/↓ switches the row (Questions · Rating · Navigation)",
  "grow.assessmentSubtitle": "Rate how strongly each statement applies to you.",
  "grow.elementAssessment.askIntro.0": "I'm rating the self-assessment statement: \"{statement}\". Help me understand what it means and how to evaluate it for myself.",
  "grow.elementAssessment.askIntro.1": "Help me make sense of this self-assessment statement: \"{statement}\". What does it mean and how should I rate it?",
  "grow.elementAssessment.askIntro.2": "I'm not sure how to rate \"{statement}\". Can you help me interpret and evaluate it?",
  "grow.elementAssessment.askIntro.3": "What is the statement \"{statement}\" really getting at, and how do I judge it for myself?",
  "grow.elementAssessment.askIntro.4": "Walk me through the statement \"{statement}\" so I can rate it honestly.",
  "grow.elementAssessment.askIntro.5": "Help me reflect on \"{statement}\" – what does it mean and how do I assess it?",
  "grow.elementAssessment.askIntro.6": "How should I think about the statement \"{statement}\" when rating myself?",
  "grow.elementAssessment.askIntro.7": "Unpack \"{statement}\" for me and help me decide how much it applies to me.",
  "grow.elementAssessment.askIntro.8": "I'm evaluating \"{statement}\". What does it mean, and what should I consider before rating it?",
  "grow.elementAssessment.askIntro.9": "Explain \"{statement}\" and help me figure out where I fall on it.",
  "grow.elementAssessment.notSaved": "not saved",
  "grow.elementAssessment.savedStatus": "saved",
  "grow.elementAssessment.savingStatus": "saving…",
  "grow.elementAssessment.statementLabel": "Statement {index}",
  "grow.elementAssessment.toEvaluation": "To evaluation",
  "grow.elementResult.answeredCount": "{answered}/{total} answered",
  "grow.elementResult.askButton": "Discuss my result",
  "grow.elementResult.askIntro.0": "I just scored {score} on {name}. Help me understand what that means and how to improve.",
  "grow.elementResult.askIntro.1": "Using the reference material, interpret my {name} result ({score}) and suggest how to grow it.",
  "grow.elementResult.askIntro.2": "What does a {name} score of {score} say about me, and what can I do about it?",
  "grow.elementResult.askIntro.3": "Help me make sense of my {name} result ({score}) and where to go from here.",
  "grow.elementResult.askIntro.4": "I got {score} on {name}. Based on the reference material, how can I develop this power?",
  "grow.elementResult.askIntro.5": "Break down my {name} result ({score}) and give me practical next steps.",
  "grow.elementResult.askIntro.6": "How should I read a {name} score of {score}? What would improvement look like?",
  "grow.elementResult.askIntro.7": "Give me reference-grounded advice for improving {name}, given my score of {score}.",
  "grow.elementResult.askIntro.8": "My {name} came out at {score}. What are concrete ways to strengthen it?",
  "grow.elementResult.askIntro.9": "Interpret my {name} result ({score}) and coach me on improving it.",
  "grow.elementResult.evaluation": "Evaluation",
  "grow.elementResult.fullyAnswered": "Fully answered",
  "grow.elementResult.lastEvaluatedOn": "Last evaluated: {date}",
  "grow.elementResult.reassess": "Assess again",
  "grow.elementResult.selfAssessmentCompleted": "Self-assessment completed",
  "grow.elementResult.toPower": "To Power",
  "grow.elementResult.toPowerMap": "To Power Map",
  "grow.elementResult.unknownElement": "Unknown element",
  "grow.elementResult.yourScore": "Your score",
  "grow.landing.progressHint": "Answer all questions about the powers to increase your profile progress.",
  "grow.mediaKind.podcast": "Podcast",
  "grow.mediaKind.script": "Script",
  "grow.mediaKind.video": "Video",
  "grow.noQuestions": "No questions available for this element.",
  "grow.play.allGames": "All games",
  "grow.play.featured": "Featured",
  "grow.play.group.duration": "approx. {minutes} min",
  "grow.play.group.kind": "Questionnaire",
  "grow.play.group.missing": "This questionnaire is not available on this environment.",
  "grow.play.headerCount": "{count, plural, one {# game} other {# games}}",
  "grow.play.intro": "Playful exercises and quizzes that get your powers moving.",
  "grow.play.personSingular": "person",
  "grow.play.quiz.continue": "Continue with part {index}",
  "grow.play.quiz.eyebrow": "Grow · Play",
  "grow.play.quiz.missing": "No questionnaires are set up on this environment yet.",
  "grow.play.quiz.partAnswered": "answered",
  "grow.play.quiz.partLabel": "Part {index}",
  "grow.play.quiz.partOpen": "open",
  "grow.play.quiz.partsProgress": "{answered} of {total} parts answered",
  "grow.play.quiz.result.backToParts": "Back to the parts",
  "grow.play.quiz.result.empty": "No powers to show yet.",
  "grow.play.quiz.result.error": "The result could not be loaded: {message}",
  "grow.play.quiz.result.firstValue": "first self-report value",
  "grow.play.quiz.result.locked": "The result opens once all parts are answered.",
  "grow.play.quiz.result.noQuizItems": "not covered by the quiz",
  "grow.play.quiz.result.openPower": "Open this power",
  "grow.play.quiz.result.quizAlone": "Quiz on its own: {score}{band, select, none {} other { · {band}}}{items, select, none {} other {, from {answered} of {total} items}}.",
  "grow.play.quiz.result.quizOnlySource": "From the quiz alone{items, select, none {} other {, {answered} of {total} items}}.",
  "grow.play.quiz.result.subtitle": "How the parts you answered moved your powers. They count towards your self-report score, weighted by how many items they contribute.",
  "grow.play.quiz.result.title": "Your result",
  "grow.play.quiz.result.unchanged": "unchanged",
  "grow.play.quiz.showResult": "Show result",
  "grow.play.quiz.start": "Start quiz",
  "grow.play.start": "Start ↗",
  "grow.play.title": "Play",
  "grow.play.tour.featured.desc": "{name} leads the catalogue: {caption} It takes {duration} and you answer it on your own. Click here to start.",
  "grow.play.tour.featured.title": "The featured questionnaire",
  "grow.play.tour.grid.desc": "The rest of the catalogue holds {count, plural, one {one more game} other {# more games}}. Click a card to start.",
  "grow.play.tour.grid.title": "All games",
  "grow.play.tour.label": "Grow Play",
  "grow.play.tour.summary": "{count, plural, one {This is the Play arcade: one game that gets your powers moving.} other {This is the Play arcade: # games that get your powers moving.}}",
  "grow.powerDetail.answeredCount": "{answered}/{total} answered",
  "grow.powerDetail.askButton": "Understand {name}",
  "grow.powerDetail.askImprove.0": "How can I improve my {name}? Give me reference-grounded, practical steps.",
  "grow.powerDetail.askImprove.1": "Based on the reference material, what are concrete ways to develop {name}?",
  "grow.powerDetail.askImprove.2": "Coach me on strengthening {name} – where do I start?",
  "grow.powerDetail.askImprove.3": "Give me exercises or habits from the reference material to grow {name}.",
  "grow.powerDetail.askImprove.4": "What does the reference material suggest for improving {name}?",
  "grow.powerDetail.askImprove.5": "Help me build a simple plan to improve {name}.",
  "grow.powerDetail.askImprove.6": "What are the best first steps to strengthen {name}?",
  "grow.powerDetail.askImprove.7": "How do people typically develop {name}? Draw on the reference material.",
  "grow.powerDetail.askImprove.8": "Give me a few practical ways to work on {name}.",
  "grow.powerDetail.askImprove.9": "I want to get better at {name}. What should I do, according to the reference material?",
  "grow.powerDetail.askImproveButton": "How do I improve {name}?",
  "grow.powerDetail.askIntro.0": "Using the reference material, give me an intro to {name} and tell me more about it.",
  "grow.powerDetail.askIntro.1": "Introduce me to {name} based on the reference material – what is it about?",
  "grow.powerDetail.askIntro.2": "Draw on the reference material to explain {name} to me.",
  "grow.powerDetail.askIntro.3": "What does the reference material say about {name}? Give me an overview.",
  "grow.powerDetail.askIntro.4": "Give me a beginner-friendly intro to {name}, grounded in the reference material.",
  "grow.powerDetail.askIntro.5": "Walk me through {name} using the reference material.",
  "grow.powerDetail.askIntro.6": "From the reference material, summarize what {name} is and why it matters.",
  "grow.powerDetail.askIntro.7": "Help me understand {name} – use the reference material for an intro.",
  "grow.powerDetail.askIntro.8": "Explain {name} to me from the reference material, as if I'm new to it.",
  "grow.powerDetail.askIntro.9": "Based on the reference material, what should I know about {name}?",
  "grow.powerDetail.confidence": "Confidence: {percent}%",
  "grow.powerDetail.continueSelfAssessment": "Continue self-assessment",
  "grow.powerDetail.evidence": "Evidence ({count})",
  "grow.powerDetail.eyebrow": "Power · {abbr}",
  "grow.powerDetail.noEvidence": "No evidence available. Upload documents into the {link} to gather evidence.",
  "grow.powerDetail.noPodcasts": "No podcasts for “{name}” yet.",
  "grow.powerDetail.noScripts": "No scripts for “{name}” yet.",
  "grow.powerDetail.noSmartAnalysis": "No smart analysis for this power yet.",
  "grow.powerDetail.noVideos": "No videos for “{name}” yet.",
  "grow.powerDetail.openDocument": "Open document",
  "grow.powerDetail.openDocumentNamed": "Open document {name}",
  "grow.powerDetail.page": "Page {number}",
  "grow.powerDetail.podcasts": "Podcasts",
  "grow.powerDetail.powerAnalysis": "power analysis",
  "grow.powerDetail.powerDetails": "Power details",
  "grow.powerDetail.questionnaires": "Questionnaires",
  "grow.powerDetail.rationale": "Rationale",
  "grow.powerDetail.repeatSelfAssessment": "Repeat self-assessment",
  "grow.powerDetail.revealPower": "Reveal “{name}”",
  "grow.powerDetail.scripts": "Scripts",
  "grow.powerDetail.selfAssessment": "Self-assessment",
  "grow.powerDetail.selfEvaluation": "Self-evaluation",
  "grow.powerDetail.selfEvaluationIntro": "Answer the statements about “{name}”. Your result feeds into the self-assessment score; once you have answered all of them you earn the medal.",
  "grow.powerDetail.smartAnalysis": "Smart Analysis",
  "grow.powerDetail.stanceContra": "Contra",
  "grow.powerDetail.stancePro": "Pro",
  "grow.powerDetail.startSelfAssessment": "Start self-assessment",
  "grow.powerDetail.tour.artwork.desc": "The artwork is only as sharp as your self-assessment is complete. So far you have answered {answered} of {total} statements. Answer more to reveal it fully.",
  "grow.powerDetail.tour.artwork.title": "The artwork reveal",
  "grow.powerDetail.tour.description.desc": "Read what \"{name}\" stands for and which cluster it belongs to. That is good grounding before you rate yourself.",
  "grow.powerDetail.tour.description.title": "What this power means",
  "grow.powerDetail.tour.label": "Grow Power",
  "grow.powerDetail.tour.selfEvaluation.desc": "Answer the statements about \"{name}\" here; {answered} of {total} are done. Completing all of them earns the medal and sharpens the artwork.",
  "grow.powerDetail.tour.selfEvaluation.doneDesc": "All {total} statements answered. Your self-assessment score is {score}. You can repeat the assessment anytime to update it.",
  "grow.powerDetail.tour.selfEvaluation.title": "Self-evaluation",
  "grow.powerDetail.tour.summary": "This page is all about the power \"{name}\" ({abbr}). {status}",
  "grow.powerDetail.tour.summaryStatus": "You have answered {answered} of {total} self-assessment statements.",
  "grow.powerDetail.tour.summaryStatusNone": "You haven't self-assessed it yet.",
  "grow.powerDetail.videos": "Videos",
  "grow.powerLibrary.all": "All",
  "grow.powerLibrary.askButton": "Understand my powers",
  "grow.powerLibrary.askIntro.0": "Read my Power Map – where are my strengths and gaps, and what should I focus on?",
  "grow.powerLibrary.askIntro.1": "Give me an overview of my powers: what's strong, what's weak, and where to grow.",
  "grow.powerLibrary.askIntro.2": "Interpret my power profile – the highs, the lows, and a suggested focus.",
  "grow.powerLibrary.askIntro.3": "Based on my powers and the reference material, what patterns do you see?",
  "grow.powerLibrary.askIntro.4": "Help me understand my overall power profile and where to invest.",
  "grow.powerLibrary.askIntro.5": "What do my strongest and weakest powers say about me?",
  "grow.powerLibrary.askIntro.6": "Summarize my power landscape and recommend a growth focus.",
  "grow.powerLibrary.askIntro.7": "Where are my biggest opportunities across my powers?",
  "grow.powerLibrary.askIntro.8": "Walk me through my Power Map and suggest what to work on first.",
  "grow.powerLibrary.askIntro.9": "Give me a big-picture read of my powers and a place to start.",
  "grow.powerLibrary.clearSearch": "Clear search",
  "grow.powerLibrary.eyebrow": "Power Map",
  "grow.powerLibrary.heading": "{count} Powers",
  "grow.powerLibrary.noResults": "No power found for “{query}”.",
  "grow.powerLibrary.onlyUnrated": "Unrated",
  "grow.powerLibrary.openPower": "Open {name}",
  "grow.powerLibrary.powerScore": "Power Score",
  "grow.powerLibrary.profileProgress": "Profile progress",
  "grow.powerLibrary.profileProgressTooltip": "Answer all questions about the powers to increase your profile progress.",
  "grow.powerLibrary.searchPlaceholder": "Search by name or abbreviation",
  "grow.powerLibrary.sourceCombined": "Combined",
  "grow.powerLibrary.sourceSelf": "Self-assessment",
  "grow.powerLibrary.sourceSmart": "Smart Analysis",
  "grow.powerLibrary.subheading": "The complete vocabulary: {clusters} clusters, {powers} powers.",
  "grow.powerLibrary.tour.filters.desc": "Search powers by name or abbreviation, or tap Unrated to see only the {unrated} powers whose self-assessment you haven't completed yet.",
  "grow.powerLibrary.tour.filters.title": "Search & filter",
  "grow.powerLibrary.tour.grid.desc": "All {total} powers grouped into {clusters} clusters. Click a tile to open that power. A medal and its artwork appear once its self-assessment is complete; {completed} earned so far.",
  "grow.powerLibrary.tour.grid.title": "The power tiles",
  "grow.powerLibrary.tour.label": "Grow Map",
  "grow.powerLibrary.tour.scoreSource.desc": "Switch which evaluation the numbers on all tiles show. Pick Self-assessment to see the scores from your own ratings.",
  "grow.powerLibrary.tour.scoreSource.title": "Score source",
  "grow.powerLibrary.tour.summary": "This is the Power Map: all {total} powers, periodic-table style. You have fully self-assessed {completed} of {total} so far.",
  "grow.powerQuestionnaires.answer": "Answer",
  "grow.powerQuestionnaires.completed": "completed",
  "grow.powerQuestionnaires.empty": "No questionnaires linked to \"{powerName}\" yet.",
  "grow.powerQuestionnaires.heading": "Questionnaires",
  "grow.powerQuestionnaires.loading": "loading…",
  "grow.powerQuestionnaires.repeat": "Repeat",
  "grow.questionnaire.eyebrow": "Grow · Questionnaire",
  "grow.questionnaire.fallbackName": "Questionnaire",
  "grow.questionnaire.noQuestions": "No questions in this questionnaire.",
  "grow.questionnaire.questionLabel": "Question {position}",
  "grow.questionnaire.submit": "Submit",
  "grow.questionnaire.unknownElement": "Unknown element",
  "grow.title": "Grow",
  "grow.unknownElement": "Unknown element",
  "grow.watch.contentCount": "{count} content items",
  "grow.watch.emptyContent": "No content available yet. As soon as videos, podcasts or scripts exist, they will appear here.",
  "grow.watch.filterAll": "All",
  "grow.watch.intro": "Content to consume around your powers: videos, podcasts and scripts. Sit down, watch, listen and read up.",
  "grow.watch.loadingContent": "Content is loading …",
  "grow.watch.title": "Watch",
  "grow.watch.tour.content.desc": "{count} content items, each tagged with its power and cluster. Click a card to consume it.",
  "grow.watch.tour.content.emptyDesc": "No content is available yet. As soon as videos, podcasts or scripts exist, they will appear here as cards you can open.",
  "grow.watch.tour.content.title": "The catalogue",
  "grow.watch.tour.emptySummary": "This is Watch: learning content around your powers as videos, podcasts and scripts. Right now there is nothing here yet.",
  "grow.watch.tour.filters.desc": "Narrow the catalogue by format (videos, podcasts or scripts), or pick All for everything.",
  "grow.watch.tour.filters.title": "Content filter",
  "grow.watch.tour.label": "Grow Watch",
  "grow.watch.tour.summary": "This is Watch: learning content around your powers as videos, podcasts and scripts. Right now there are {count} items here.",
  "home.allMatches": "All matches ↗",
  "home.candidatesCount": "{count, plural, one {# candidate} other {# candidates}}",
  "home.carouselSlide": "Slide {number}",
  "home.certificate": "Certificate",
  "home.communitiesSub": "{count, plural, one {# community} other {# communities}}",
  "home.community": "Community",
  "home.contacts": "Contacts",
  "home.documents": "Documents",
  "home.education": "Education",
  "home.entries": "entries",
  "home.greeting": "Glad you're here.",
  "home.inComparison": "In comparison · Community",
  "home.myPosts": "My posts ↗",
  "home.noCommunity": "No community yet.",
  "home.noContacts": "no contacts yet",
  "home.noMatches": "No matches",
  "home.noOwnPosts": "No posts of your own yet",
  "home.noOwnPostsHint": "create a project or a post",
  "home.noPins": "nothing pinned yet",
  "home.viewCommunities": "Show communities",
  "home.viewPins": "Show pins",
  "home.profileVisitors": "Profile visitors",
  "home.lastVisitor": "last: {name}",
  "home.noVisitsYet": "no views yet",
  "home.notRatedYet": "not rated yet",
  "home.notStarted": "not started yet",
  "home.upNext": "Up next",
  "home.upNextFirst": "next: {name}",
  "home.allAssessmentsDone": "all self-assessments completed",
  "home.strengths": "Strengths",
  "home.roomToGrow": "Room to grow",
  "home.viewStrengths": "Show strengths",
  "home.viewRoomToGrow": "Show room to grow",
  "home.openProfileOf": "Open {name}",
  "home.personsCount": "{count, plural, one {# person} other {# people}}",
  "home.pins": "Pins",
  "home.postsCount": "{count, plural, one {# post} other {# posts}}",
  "home.profile": "Profile",
  "home.profileEmpty": "nothing recorded yet",
  "home.profileFallback": "Profile",
  "home.profileProgress": "Profile progress",
  "home.projectsCount": "{count, plural, one {# project} other {# projects}}",
  "home.service": "Documents",
  "home.serviceEmpty": "nothing filed yet",
  "home.tour.grow.desc": "Your profile progress, strongest powers and open self-assessments.",
  "home.tour.grow.title": "Grow",
  "home.tour.label": "Home",
  "home.tour.match.desc": "Your matches. Click one to continue where you left off.",
  "home.tour.match.title": "Match",
  "home.tour.save.desc": "Your profile entries, documents, contacts and pins, with quick actions to add new ones.",
  "home.tour.save.title": "Save",
  "home.tour.share.desc": "Your posts and projects and what is happening around them.",
  "home.tour.share.title": "Share",
  "home.tour.summary": "This is the main page: the latest numbers from every section at a glance. Every tile links to its spot in the app.",
  "home.unnamedMatch": "Unnamed match",
  "home.uploadFile": "Upload file",
  "home.viewAll": "View all ↗",
  "home.viewPowerMap": "Show Power Map",
  "home.viewResult": "View result",
  "home.welcomeHint.dismiss": "Dismiss",
  "home.workExperience": "Work experience",
  "invite.conflict": "This address already has access, so no invitation was sent.",
  "invite.created": "Invitation sent.",
  "invite.emailLabel": "Email address",
  "invite.emailPlaceholder": "name@partner.example",
  "invite.eyebrow": "Access · Invitation",
  "invite.heading": "Invite an external person",
  "invite.intro": "They receive an access link valid for 72 hours and set their own password. The link works once and only for this address.",
  "invite.invalidEmail": "Please enter a valid email address.",
  "invite.resent": "This person had already been invited. The access link was sent again.",
  "invite.sending": "Sending…",
  "invite.submit": "Send invitation",
  "likert.1": "Does not apply",
  "likert.2": "Rather does not apply",
  "likert.3": "Partly",
  "likert.4": "Rather applies",
  "likert.5": "Fully applies",
  "linkedin.error.authorize_denied": "LinkedIn authorization was cancelled.",
  "linkedin.error.cancelled": "You cancelled the LinkedIn connection. You can connect again whenever you're ready.",
  "linkedin.error.import_failed": "The import failed. Please try again later.",
  "linkedin.error.invalid_callback": "The LinkedIn response was incomplete. Please try again.",
  "linkedin.error.invalid_state": "The LinkedIn session expired. Please try again.",
  "linkedin.error.not_configured": "LinkedIn import is not configured. Contact your administrator.",
  "linkedin.error.reconnect": "Your LinkedIn session expired or access wasn't complete. Please reconnect.",
  "linkedin.error.snapshotNotReady": "LinkedIn hasn't returned any data yet. Most likely your data export isn't ready: we requested it through the LinkedIn import just now, and LinkedIn can take up to 10 minutes to prepare it. Try again shortly or come back later.",
  "linkedin.error.stillImporting": "Your import is taking longer than expected. It's still running – refresh this page in a moment to see the result.",
  "linkedin.error.temporary": "LinkedIn didn't respond in time. Please try again in a moment.",
  "linkedin.error.token_exchange": "Could not connect to LinkedIn. Please try again later.",
  "linkedin.error.unavailable": "LinkedIn import isn't available right now. Please contact your administrator.",
  "linkedin.error.unexpected": "Something went wrong during the import. Please try again later.",
  "linkedin.import.abort": "Abort import",
  "linkedin.import.abortTip": "Still importing – you can keep waiting, or abort and start the import over from the beginning. Nothing has been saved yet.",
  "linkedin.import.alreadyUpToDate": "Everything LinkedIn could add is already in your profile.",
  "linkedin.import.close": "Close",
  "linkedin.import.comeBackLater": "Come back later",
  "linkedin.import.connect": "Connect LinkedIn",
  "linkedin.import.dialogTitle": "LinkedIn import",
  "linkedin.import.elapsed": "Elapsed time: {time}",
  "linkedin.import.field.bio": "Bio",
  "linkedin.import.field.currentEmployer": "Current employer",
  "linkedin.import.field.dateOfBirth": "Date of birth",
  "linkedin.import.field.degree": "Degree",
  "linkedin.import.field.description": "Description",
  "linkedin.import.field.email": "Email",
  "linkedin.import.field.employer": "Employer",
  "linkedin.import.field.endDate": "End date",
  "linkedin.import.field.fieldOfStudy": "Field of study",
  "linkedin.import.field.institution": "Institution",
  "linkedin.import.field.issued": "Issued",
  "linkedin.import.field.jobTitle": "Job title",
  "linkedin.import.field.language": "Language",
  "linkedin.import.field.level": "Level",
  "linkedin.import.field.location": "Location",
  "linkedin.import.field.name": "Name",
  "linkedin.import.field.period": "Period",
  "linkedin.import.field.phone": "Phone",
  "linkedin.import.field.profession": "Profession",
  "linkedin.import.field.skill": "Skill",
  "linkedin.import.field.startDate": "Start date",
  "linkedin.import.field.street": "Street",
  "linkedin.import.field.title": "Title",
  "linkedin.import.field.zipCode": "Zip code",
  "linkedin.import.importing": "Importing your LinkedIn data – this can take up to a minute…",
  "linkedin.import.intro": "Connect your LinkedIn account to import your profile, positions and skills. You'll review what to keep or replace before anything is saved.",
  "linkedin.import.loadingResult": "Finishing import…",
  "match.result.facts.aiMark": "AI",
  "match.result.powersColWeight": "Weighting",
  "match.result.powersColPower": "Power",
  "match.result.powersColStrongInfo": "How many in the team score above {threshold} on this power.",
  "match.result.powersColStrong": "strong >{threshold}",
  "match.result.powersListHeader": "Top Powers",
  "match.result.powersSortScore": "By team score",
  "match.result.powersSortWish": "By weighting",
  "match.result.ranking.actualInline": "Evidence:",
  "match.result.ranking.assessment.interviewQuestions": "Questions for the conversation",
  "match.result.ranking.assessment.ratingVeryHigh": "Highly suitable",
  "match.result.ranking.assessment.ratingHigh": "Suitable",
  "match.result.ranking.assessment.ratingMedium": "Partly suitable",
  "match.result.ranking.assessment.ratingLow": "Rather unsuitable",
  "match.result.ranking.assessment.ratingVeryLow": "Unsuitable",
  "match.result.ranking.fulfilledTab": "Fulfilled ({count})",
  "match.result.ranking.unfulfilledTab": "Not fulfilled ({count})",
  "match.result.suitability.basis": "AI overall assessment",
  "match.result.suitability.empty": "No AI suitability scores yet. Please run the match again.",
  "match.result.suitability.header": "Top 5 – best fit",
  "match.result.suitability.openProfile": "{name} – open profile",
  "match.result.suitability.rankLabel": "Rank {rank}",
  "match.result.suitability.scoreLabel": "AI suitability {score}%",
  "match.weightInput.label": "Weight for {power}",
  "nav.myCompanies": "My companies",
  "nav.newCompany": "New company",
  "profile.merge.save": "Save changes",
  "profile.merge.saving": "Saving…",
  "profile.merge.saveFailed": "This change could not be saved.",
  "profile.merge.savePartial": "{count, plural, one {# change couldn't be saved. Please try again.} other {# changes couldn't be saved. Please try again.}}",
  "profile.merge.dateBlocked": "Some dates need fixing before saving.",
  "profile.merge.fieldBlocked": "Some values need fixing before saving.",
  "profile.merge.languageBlocked": "Choose a real language for the imported entry, or skip it.",
  "profile.merge.language.unknown": "“{value}” is not a recognizable language. Choose the right one, or skip this entry.",
  "profile.merge.reviewBlocked": "Review every change before saving.",
  "profile.merge.date.future": "This date can't be in the future.",
  "profile.merge.date.format": "Use a date like YYYY, YYYY-MM or YYYY-MM-DD.",
  "profile.merge.date.range": "End date must be on or after the start date.",
  "profile.merge.date.beforeBirth": "This date is before the date of birth.",
  "profile.merge.field.tooLong": "Keep this to {max} characters or fewer.",
  "profile.merge.field.invalidEmail": "Enter a valid email address.",
  "profile.merge.field.invalidUrl": "Enter a valid web address.",
  "profile.merge.field.invalidPhone": "Enter a valid phone number.",
  "profile.merge.field.childCountNegative": "The number of children cannot be negative.",
  "profile.merge.field.childCountMax": "The number of children cannot exceed {max}.",
  "profile.merge.bar.aria": "Import changes",
  "profile.merge.bar.open": "{count, plural, one {# field left to review} other {# fields left to review}}",
  "profile.merge.bar.allReviewed": "All changes reviewed",
  "profile.merge.bar.previous": "Previous",
  "profile.merge.bar.next": "Next",
  "profile.merge.guide.step": "{current, number} of {total, number}",
  "profile.merge.guide.review": "Review",
  "profile.merge.status.keep": "Keeping your value",
  "profile.merge.status.use": "Using the imported value",
  "profile.merge.status.add": "Will be added",
  "profile.merge.status.skip": "Skipped",
  "profile.merge.keepAll": "Keep all mine",
  "profile.merge.useAll": "Use all imported",
  "profile.merge.skip": "Skip",
  "profile.merge.add": "Add",
  "profile.merge.showMore": "Show more",
  "profile.merge.showLess": "Show less",
  "profile.merge.badge.new": "New",
  "profile.merge.badge.conflict": "Differs",
  "profile.merge.incomingLabel": "Imported",
  "profile.merge.keep": "Keep mine",
  "profile.merge.use": "Use imported",
  "profile.merge.chooseAria": "Keep your value or use the imported one",
  "profile.merge.side.existing": "Your value",
  "profile.merge.editAria.existing": "Edit your value",
  "profile.merge.editAria.incoming": "Edit the imported value",
  "profile.merge.reset.existing": "Reset to your saved value",
  "profile.merge.reset.incoming": "Reset to the imported value",
  "profile.merge.replacesSaved": "Replaces your saved value",
  "profile.merge.replacesSavedRow": "Replaces your saved entry",
  "profile.merge.skills.importAllAria": "Import all skills",
  "profile.merge.cefr.native": "Native",
  "linkedin.import.openingReview": "Opening your profile to review the changes…",
  "linkedin.import.retry": "Try again",
  "linkedin.import.retryIn": "Try again ({time})",
  "linkedin.import.warning.certificateInvalidName": "A certificate was skipped because its name was invalid.",
  "linkedin.import.warning.certificateNameDefaulted": "A certificate had no name and was imported with a placeholder.",
  "linkedin.import.warning.educationInvalidStartDate": "An education entry was skipped because its start date was invalid.",
  "linkedin.import.warning.educationMissingFieldOfStudyAndDegree": "An education entry was skipped because it had no field of study or degree.",
  "linkedin.import.warning.educationStartDateDefaulted": "An education entry had no start date and was set to the current month.",
  "linkedin.import.warning.experienceInvalidJobTitle": "A position was skipped because its job title was invalid.",
  "linkedin.import.warning.experienceInvalidStartDate": "A position was skipped because its start date was invalid.",
  "linkedin.import.warning.experienceJobTitleDefaulted": "A position had no job title and was imported with a placeholder.",
  "linkedin.import.warning.experienceStartDateDefaulted": "A position had no start date and was set to the current month.",
  "linkedin.import.warning.languageMissingName": "A language was skipped because it had no name.",
  "linkedin.import.warning.languageTagTooLong": "A language was skipped because its name was too long.",
  "linkedin.import.warning.languageUnrecognizedName": "A language was skipped because its name wasn't recognized.",
  "linkedin.import.warning.languageUnrecognizedProficiency": "A language's proficiency level wasn't recognized.",
  "match.addDocumentsAriaLabel": "Add documents",
  "match.agenticAi": "Agentic AI",
  "match.agenticAiBoxDesc": "Record which AI agents this project works with. They are context, not team members: they take no seat on the team, but the requirements adapt to them.",
  "match.agent.covers": "Covers",
  "match.agent.tools": "Tools",
  "match.agent.mcp": "MCP",
  "match.agent.guardrails": "Guardrails",
  "match.agent.remove": "Remove {name}",
  "match.agent.none": "No agents recorded yet.",
  "match.agent.recommend": "Recommend agents",
  "match.agent.recommendHint": "Opens the assistant, which suggests fitting agents from your description.",
  "match.agent.recommendPrompt": "Which AI agents fit this project?",
  "match.agent.recommendContext": "Answer the question using the following information. Name two to four agents, each with a one-sentence reason, and say how the requirements for the human team members change as a result. Agents are project context and never team members. You cannot store the selection yourself and have no tool for it: name the agents, I will record them.\n\nProject:\n{project}\n\nAlready recorded: {selected}\n\nAvailable agents:\n{catalogue}",
  "match.agent.noneShort": "none",
  "match.agent.browse": "Choose agents",
  "match.agent.catalogueTitle": "Available agents",
  "match.agent.add": "Add",
  "match.agent.added": "Added",
  "match.agenticAiOff": "Agentic AI off",
  "match.agenticAiOn": "Agentic AI on",
  "match.agenticAiQuestion": "Should this match be supported by Agentic AI?",
  "match.challenge.aiAssist": "AI assistance",
  "match.challenge.aiAssistHint": "AI considers the whole profile and judges whether requirements are met even without explicit evidence. It also writes an assessment with a score for every person.",
  "match.challenge.aiAssistHintReduced": "AI considers the whole profile and judges whether requirements are met even without explicit evidence.",
  "match.challenge.aiDeriveHint": "Opens the assistant to suggest requirements from your brief.",
  "match.challenge.aiFillFirstHint": "Add a description first.",
  "match.challenge.describeProject": "Describe project",
  "match.challenge.describeRole": "Describe role",
  "match.challenge.enterTitle": "Enter title",
  "match.challenge.generateRequirementsPrompt": "Suggest suitable requirements from the title, short and detailed description.",
  "match.challenge.generateWithAi": "Generate for me",
  "match.challenge.interview.invite": "Not sure what to write? Let the assistant interview you.",
  "match.challenge.interview.refine": "Refine with an interview",
  "match.challenge.interview.seed": "Interview me about this project so we get a good project description.",
  "match.challenge.linkBtn": "Link",
  "match.challenge.linkProjectTitle": "Link project to an existing Share item",
  "match.challenge.noFilesYet": "No files yet.",
  "match.challenge.openLinkedShare": "Open linked Share item",
  "match.challenge.projectTitleLabel": "Project title",
  "match.challenge.roleTitleLabel": "Role title",
  "match.challenge.publishBtn": "Publish",
  "match.challenge.requirements": "Requirements",
  "match.challenge.requirementsSharedInfo": "Only profile information that candidates have shared is taken into account.",
  "match.challenge.unlink": "Unlink",
  "match.challenge.unlinkTitle": "Unlink from Share item",
  "match.challenge.unnamedSharedItem": "Unnamed Share item",
  "match.charsCount": "{count} characters",
  "match.detail.error": "Error: {message}",
  "match.detail.invalidUrl": "Invalid match URL.",
  "match.detail.loading": "Loading…",
  "match.detail.notFound": "Match not found.",
  "match.detailedPlaceholder": "Context, outcome, constraints, prior experience, anything else relevant.",
  "match.docs.retry": "↻ Retry",
  "match.docs.tooLarge": "Too large (max. {max} MB per file): {names}",
  "match.docs.uploadFailed": "Upload failed.",
  "match.docs.uploading": "Uploading…",
  "match.documents": "Documents",
  "match.dropFiles": "Drag files <b>here</b> or click",
  "match.editor.reset": "Reset",
  "match.fieldDetailedDesc": "Detailed description",
  "match.fieldShortDesc": "Short description",
  "match.freitext.addJobTitle": "Job title",
  "match.freitext.jobTitlePlaceholder": "e.g. Senior Designer, Lead Engineer",
  "match.freitext.title": "Work Experience",
  "match.group.COMMUNICATION": "Communication",
  "match.group.FUTURE_ORIENTATION": "Future Orientation",
  "match.group.INVENTIVENESS": "Inventiveness",
  "match.group.RESILIENCE": "Resilience",
  "match.group.RESULT_ORIENTATION": "Result Orientation",
  "match.group.TEAM_SPIRIT": "Teamability",
  "match.labelLanguage": "Language",
  "match.landing.body": "Initiate a match, define requirements and let the solver compose people and agentic AI into an optimal team – transparent, weighted, explainable.",
  "match.landing.candidatesCount": "{count} candidates",
  "match.landing.error": "Error: {message}",
  "match.landing.loading": "loading…",
  "match.landing.newMatch": "Create new match ↗",
  "match.landing.noMatches": "No matches",
  "match.landing.noMatchesHint": "… or not signed in",
  "match.landing.resultsCount": "{count} results",
  "match.landing.subtitle": "From the idea of a team{br}to the best team.",
  "match.landing.yourMatches": "Your Matches",
  "match.matchNameLabel": "Match name",
  "match.new.accessLabel": "Access",
  "match.new.create": "Create",
  "match.new.creating": "Creating …",
  "match.new.defaultName": "New match",
  "match.new.title": "Create a new match",
  "match.modal.accessCount": "Access · {count}",
  "match.modal.addPersonPlaceholder": "+ Add person – search by name …",
  "match.modal.chooseShareItem": "Choose Share item",
  "match.modal.fillTitle": "Fill the project from the Share item",
  "match.modal.link": "Link",
  "match.modal.linkOnly": "Link only",
  "match.modal.linkOnlyTitle": "Link without copying contents",
  "match.modal.linkWithShareItem": "Link to Share item",
  "match.modal.linking": "Linking …",
  "match.modal.loadingEllipsis": "loading …",
  "match.modal.matchNotes": "Match notes",
  "match.modal.matchNotesPlaceholder": "Internal notes, context or open questions – not the project description.",
  "match.modal.myShareItems": "My Share items",
  "match.modal.myShareItemsCount": "My Share items · {count}",
  "match.modal.nameNotesAccess": "Name, notes & access",
  "match.modal.noAccessYet": "Nobody has access yet. Add a person below.",
  "match.modal.noHits": "No hits.",
  "match.modal.noWriteRights": "You don't have write access to these match settings.",
  "match.modal.overwriteTitle": "Overwrite project contents with the Share item",
  "match.modal.owner": "Owner",
  "match.modal.ownerCreatedBy": "Owner · created by",
  "match.modal.publishEyebrow": "Publish",
  "match.modal.publishHint": "Image, theme and audience need to be added afterwards in the Share editor.",
  "match.modal.publishNow": "Publish now",
  "match.modal.publishOpenInEditor": "Open in editor",
  "match.modal.publishOpeningEditor": "Opening …",
  "match.modal.publishPublishing": "Publishing …",
  "match.modal.publishQuestion": "How do you want to publish the project as a Share item?",
  "match.modal.removeLink": "Remove link?",
  "match.modal.roleAdmin": "Admin",
  "match.modal.roleEditor": "Editor",
  "match.modal.roleHintAdmin": "Manage all content + access",
  "match.modal.roleHintEditor": "Edit content",
  "match.modal.roleHintReader": "View only",
  "match.modal.roleReader": "Reader",
  "match.modal.savingEllipsis": "Saving …",
  "match.modal.searchByName": "Search by name …",
  "match.modal.searchingEllipsis": "searching …",
  "match.modal.takeOver": "Take over",
  "match.modal.unlinkAction": "Unlink",
  "match.modal.unlinkBody": "The link to <b>{name}</b> will be removed.",
  "match.modal.unlinkEyebrow": "Unlink",
  "match.modal.unlinkHint": "The copied content (title, description, documents) stays – only the reference to the Share item disappears.",
  "match.modal.unlinking": "Unlinking …",
  "match.modal.unnamedShareItem": "Unnamed Share item",
  "match.modal.visibleToMe": "Visible to me",
  "match.modal.visibleToMeCount": "Visible to me · {count}",
  "match.modePicker.assessOutput": "verdict + gaps",
  "match.modePicker.assessSlogan": "You already have a team in mind and want to see how well it fits and where the gaps are.",
  "match.modePicker.assessTitle": "Assess team",
  "match.modePicker.optimizeTitle": "Optimize team",
  "match.modePicker.rankTitle": "Rank candidates",
  "match.modePicker.optimizeOutput": "one team",
  "match.modePicker.optimizeSlogan": "You have a pool of people and need to form the best team for a project or task.",
  "match.modePicker.outputLabel": "Result",
  "match.modePicker.rankOutput": "ranked list",
  "match.modePicker.rankSlogan": "You're filling an open position and want candidates sorted by who fits best.",
  "match.modePicker.title": "What question should this match answer?",
  "match.noMatchesEmpty": "No matches",
  "match.noPeopleFound": "No people found",
  "match.optChoose": "– choose –",
  "match.people.addAll": "Add all ({count})",
  "match.people.addAllFromSet": "Add all {count} from {name}",
  "match.people.addAllPinned": "Add all {count} pinned",
  "match.people.addInterested": "Add interested people ({count})",
  "match.people.addUpTo": "Add up to {count} matching",
  "match.people.added": "Added",
  "match.people.allPinned": "All pinned",
  "match.people.evaluateLocked": "Evaluate this team",
  "match.people.evaluateLockedTitle": "Evaluate this fully-locked team",
  "match.people.emptyCandidates": "No candidates yet – add them on the left via search or filters.",
  "match.people.finderTitle": "Person Finder",
  "match.people.interestedExplain": "People who showed interest in this project",
  "match.people.intro": "Search and filter people from your company and add them as candidates.",
  "match.people.introLock": "Mark individual people as locked candidates when they must be part of the team.",
  "match.people.lockAsFix": "Mark as fix in team",
  "match.people.personGroups": "Groups",
  "match.people.pinGroups": "Pin groups",
  "match.people.sampleNotice": "Candidate pool contains the first {count} of {total} matching people from the last bulk add.",
  "match.people.sampleNoticeCapped": "Candidate pool contains the first {count} matching people; more matched than could be added at once.",
  "match.people.savedSetsPlaceholder": "Groups & pins …",
  "match.people.searchPlaceholder": "Name, job title …",
  "match.people.selectedCandidates": "Selected Candidates",
  "match.people.unlock": "Unlock",
  "match.placeholderCount": "Count",
  "match.preSolve.assessTeam": "Assess team",
  "match.preSolve.assessing": "Assessing team…",
  "match.preSolve.rankCandidates": "Rank candidates",
  "match.preSolve.ranking": "Ranking…",
  "match.preSolve.candidatesLoaded": "Candidates loaded",
  "match.preSolve.conditionsComplete": "Criteria complete",
  "match.preSolve.conditionsIncompleteHint": "{n, plural, one {# criterion without a selection (e.g. choose an industry) – complete or remove it} other {# criteria without a selection – complete or remove them}}",
  "match.preSolve.eyebrow": "Ready to solve",
  "match.preSolve.eyebrowAssess": "Ready to assess",
  "match.preSolve.eyebrowRank": "Ready to rank",
  "match.preSolve.headingAssess": "Assess how well your team meets the requirements.",
  "match.preSolve.headingRank": "Rank your candidates by fit to the requirement profile.",
  "match.challenge.assessmentDetail": "Level of detail",
  "match.challenge.assessmentDetailBullets": "Bullet points",
  "match.challenge.assessmentDetailBulletsDescription": "Compact points separated by line breaks.",
  "match.challenge.assessmentDetailInfo": "Explain level of detail",
  "match.challenge.assessmentDetailLongText": "Long text",
  "match.challenge.assessmentDetailLongTextDescription": "Detailed reasoning with concrete evidence.",
  "match.challenge.assessmentDetailSentences": "Sentences",
  "match.challenge.assessmentDetailSentencesDescription": "Short, complete sentences.",
  "match.challenge.assessmentOutcomeBalanced": "Balanced",
  "match.challenge.assessmentOutcomeBalancedDescription": "Strengths, risks, and open questions are weighted equally in the overall assessment.",
  "match.challenge.assessmentOutcomeFocus": "Outcome focus",
  "match.challenge.assessmentOutcomeFocusInfo": "Explain outcome focus",
  "match.challenge.assessmentOutcomeOpportunities": "Opportunities",
  "match.challenge.assessmentOutcomeOpportunitiesDescription": "Strengths, transferable capabilities, and realistic opportunities are weighted more heavily and shown first.",
  "match.challenge.assessmentOutcomeRisks": "Risks",
  "match.challenge.assessmentOutcomeRisksDescription": "Risks, missing evidence, and open questions are weighted more heavily and shown first.",
  "match.challenge.assessmentStrictness": "Evaluation strictness",
  "match.challenge.assessmentStrictnessExtreme": "Extreme",
  "match.challenge.assessmentStrictnessExtremeDescription": "Only explicit, role-relevant evidence carries strong weight; uncertainties materially limit the result.",
  "match.challenge.assessmentStrictnessInfo": "Explain evaluation strictness",
  "match.challenge.assessmentStrictnessNormal": "Normal",
  "match.challenge.assessmentStrictnessNormalDescription": "The three AI perspectives assess evidence and uncertainty with normal strictness.",
  "match.challenge.assessmentStrictnessStrict": "Strict",
  "match.challenge.assessmentStrictnessStrictDescription": "Unclear or merely implied experience is rated more cautiously within the scoring band.",
  "match.challenge.hrPromptLabel": "Assessment style",
  "match.challenge.requirementLeniency": "Requirement check",
  "match.challenge.requirementLeniencyInfo": "Explain requirement check",
  "match.challenge.requirementLeniencyLenient": "Lenient",
  "match.challenge.requirementLeniencyLenientDescription": "The required level is a guideline: present expertise suffices.",
  "match.challenge.requirementLeniencyMustStrict": "Lenient for optional",
  "match.challenge.requirementLeniencyMustStrictDescription": "Must criteria have to reach the level, presence suffices for optional ones.",
  "match.challenge.requirementLeniencyStrict": "Strict for both",
  "match.challenge.requirementLeniencyStrictDescription": "Must and optional criteria have to reach the required level.",
  "match.preSolve.fulfillFirst": "Satisfy the requirements above first.",
  "match.preSolve.fullyLockedHint": "All {teamSize} seats are filled by locked members. The Solver will only evaluate this team, not optimize it.",
  "match.preSolve.lockedExceedsHeading": "More people are locked than there are seats.",
  "match.preSolve.lockedExceedsBody": "{locked} people are locked in, but the team has {teamSize} seats. Unlock some members or raise the team size before solving.",
  "match.preSolve.heading": "Compose an optimal team from your candidate pool.",
  "match.preSolve.intro": "The Solver distributes your candidates across {teamSize} slots and optimizes against your requirement profile. You can re-run the calculation as often as you like.",
  "match.preSolve.noSizeYet": "no size chosen yet",
  "match.preSolve.personsCount": "{n} people",
  "match.preSolve.poolOnly": "{n} in pool",
  "match.preSolve.poolWithLocked": "{n} in pool · {locked} fix",
  "match.preSolve.solverRunning": "Solver running…",
  "match.preSolve.startSolver": "Start Solver",
  "match.preSolve.teamSizePlaceholder": "n",
  "match.preSolve.teamSizeSet": "Team size set",
  "match.profilesLoadError": "Loading profiles: {message}",
  "match.publishToShare": "Publish as project in Share",
  "match.readOnlyBanner": "You can only view this match. Ask an admin or owner for write access.",
  "match.renameLabel": "Rename match",
  "match.recruiting.addBranche": "Industry",
  "match.recruiting.addCertificate": "Certificate",
  "match.recruiting.addEducation": "Education",
  "match.recruiting.addSkillHere": "Add expertise here",
  "match.recruiting.branchePlaceholder": "Choose industry",
  "match.recruiting.certificatePlaceholder": "e.g. AWS Solutions Architect",
  "match.recruiting.qualificationsTitle": "Education & certificates",
  "match.recruiting.educationDegreePlaceholder": "Select degree",
  "match.recruiting.educationDegreeLabel": "Required degree",
  "match.recruiting.educationLevelInfo.aria": "Explain AI degree evaluation",
  "match.recruiting.educationLevelInfo.title": "Degree evaluation",
  "match.recruiting.educationLevelInfo.body": "Without AI, the selected catalogue entry is compared directly. With AI enabled, the model is instructed to also consider equivalent or clearly higher formal qualifications.",
  "match.recruiting.experienceTitle": "Required work experience",
  "match.recruiting.expertiseTitle": "Required expertise (min.)",
  "match.recruiting.kann.tooltip": "Optional criterion: counts toward the fit score. Click to make it a must.",
  "match.recruiting.minYears": "min.",
  "match.recruiting.must.tooltip": "Must criterion: anyone who does not meet it is unqualified. Click to make it optional.",
  "match.recruiting.personCountLabel": "Minimum number of people",
  "match.recruiting.skillPlaceholder": "e.g. wound care",
  "match.recruiting.unrated": "Present",
  "match.recruiting.years": "Years",
  "match.recruiting.yearsUnit": "years",
  "match.removeAll": "Remove all",
  "match.requirements.aria.cefrLevel": "Level",
  "match.requirements.aria.composition": "Composition",
  "match.requirements.aria.operator": "Operator",
  "match.requirements.cefr.A1": "A1 – Beginner",
  "match.requirements.cefr.A2": "A2 – Elementary",
  "match.requirements.cefr.B1": "B1 – Intermediate",
  "match.requirements.cefr.B2": "B2 – Upper intermediate",
  "match.requirements.cefr.C1": "C1 – Advanced",
  "match.requirements.cefr.C2": "C2 – Proficient",
  "match.requirements.cefr.NATIVE": "Native",
  "match.requirements.condition.annualSalary": "Annual salary",
  "match.requirements.otherUnchanged": "{count, plural, one {# other requirement stays} other {# other requirements stay}} unchanged.",
  "match.requirements.personDetails": "Person Details",
  "match.result.adjustRequirements": "Adjust requirements",
  "match.result.adjustTeamSize": "Team size",
  "match.result.age": "Age",
  "match.result.agentsIntro": "The AI agents this project works with. They are context, not team members: the team above is people only.",
  "match.result.agentsTitle": "Agents",
  "match.result.analysis.extraSkills": "Strong in the team, not requested: {skills}",
  "match.result.backToSelection": "← Close",
  "match.result.candidatesMeta": "{count, plural, one {# candidate} other {# candidates}}",
  "match.result.condition.age": "Age",
  "match.result.condition.annualSalary": "Salary",
  "match.result.condition.certificate": "Certificate",
  "match.result.condition.children": "Children",
  "match.result.condition.citizenship": "Citizenship",
  "match.result.condition.city": "Place of residence",
  "match.requirements.cityRadius": "Radius in kilometres",
  "match.requirements.cityRadiusDial": "Choose radius, drag outwards from the centre",
  "match.requirements.cityRadiusHint": "Drag up to 100 km, enter larger values above",
  "match.result.analysis.carriersClose": "Close: {names}",
  "match.result.analysis.carriersMet": "Met by: {names}",
  "match.result.analysis.carriersNone": "Nobody in the team meets this.",
  "match.result.analysis.donutFulfilled": "met",
  "match.result.analysis.fulfilment": "Fulfilment",
  "match.result.analysis.gaps": "Gaps",
  "match.result.analysis.metOfTotal": "{met}/{total} met",
  "match.result.analysis.moreRows": "+{count} more",
  "match.result.analysis.noStrengths": "Nothing met yet.",
  "match.result.analysis.recAllMet": "All requirements met.",
  "match.result.analysis.rowClose": "{n} close",
  "match.result.analysis.rowCompositionAll": "everyone in the team",
  "match.result.analysis.rowCompositionExact": "exactly {n} in the team",
  "match.result.analysis.rowCompositionMax": "max. {n} in the team",
  "match.result.analysis.rowCompositionMin": "min. {n} in the team",
  "match.result.analysis.rowToggleAria": "Show who covers {label}",
  "match.result.analysis.rowMetOf": "{met} of {total}",
  "match.result.analysis.soleCarrier": "only {name}",
  "match.result.analysis.strengths": "Strengths",
  "match.result.condition.country": "Country",
  "match.result.condition.department": "Department",
  "match.result.condition.driversLicense": "Driver's license",
  "match.result.condition.education": "Education",
  "match.result.condition.exact": "{label}: {value}",
  "match.result.condition.exactNot": "{label}: not {value}",
  "match.result.condition.experience": "Experience",
  "match.result.condition.expertise": "Expertise",
  "match.result.condition.gender": "Gender",
  "match.result.condition.industry": "Industry",
  "match.result.condition.language": "Language",
  "match.result.condition.location": "Work location",
  "match.result.condition.maritalStatus": "Marital status",
  "match.result.condition.nationality": "Nationality",
  "match.result.condition.present": "{label}: Present",
  "match.result.condition.presentActual": "Present",
  "match.result.condition.threshold": "{label}: {word} {value}",
  "match.result.condition.thresholdExact": "exactly",
  "match.result.condition.thresholdMax": "max.",
  "match.result.condition.thresholdMin": "min.",
  "match.result.condition.thresholdNot": "not",
  "match.result.dataHint": "Data note",
  "match.result.deleteAriaLabel": "Delete result “{name}”",
  "match.result.deleteConfirmBody": "The saved result <b>“{name}”</b> will be permanently removed. This action cannot be undone.",
  "match.result.deleteConfirmTitle": "Delete result?",
  "match.result.deleteFinal": "Delete permanently",
  "match.result.deleteTitle": "Delete",
  "match.result.deleting": "Deleting…",
  "match.result.dept": "Dept",
  "match.result.detailsHeader": "Details",
  "match.result.discardUnsavedConfirm.confirm": "Discard",
  "match.result.discardUnsavedConfirm.message": "The computed result hasn't been saved yet and will be lost when you go back.",
  "match.result.discardUnsavedConfirm.title": "Discard unsaved result?",
  "match.result.dismissDataHint": "Dismiss data note",
  "match.result.elementRequirementsFulfilled": "Element Requirements · {count} fulfilled",
  "match.result.emptyHint": "No data in the result.",
  "match.result.facts.matchedBadge": "Contributes to {met} of {total} requirements",
  "match.result.facts.mustViolated": "{count, plural, one {# must criterion is not met} other {# must criteria are not met}}.",
  "match.result.factsAndSkills": "Requirements matrix",
  "match.result.gender": "Gender",
  "match.result.groupBasics": "Basics",
  "match.result.groupExpertise": "Expertise",
  "match.result.groupTotal": "Total",
  "match.result.hintNoConditionsBody": "This match has no requirements in the Challenge step – so the match analysis and the requirements matrix stay empty. Define conditions to see how the team fulfils them.",
  "match.result.hintNoConditionsLabel": "No requirements defined",
  "match.result.hintNoDemographicsBody": "The people have no birth dates and no gender on file. Department, gender and age below the team therefore stay hidden.",
  "match.result.hintNoDemographicsLabel": "No demographic data",
  "match.result.hintNoPowersBody": "The selected people have not self-assessed their powers. All powers panels therefore stay at zero. As soon as they maintain powers in their profile, the result fills in automatically.",
  "match.result.hintNoPowersLabel": "No power self-assessments",
  "match.result.historyLoading": "Saved results loading …",
  "match.result.historyTitle": "Saved results",
  "match.result.infeasibleBody": "The conditions contradict each other or your candidate pool is too small. Remove hard filters or enlarge the pool, then start the Solver again.",
  "match.result.infeasibleLockedTitle": "Locked candidates block the solve",
  "match.result.infeasibleLockedHeading": "The locked members alone can't form a valid team.",
  "match.result.infeasibleLockedBody": "Too many people are locked in, or the locked members already violate a requirement. Unlock some members or raise the team size, then run the Solver again.",
  "match.result.infeasibleRelaxTitle": "{count, plural, one {Relax this must criterion} other {Smallest fix: relax all of these must criteria}}",
  "match.result.infeasibleShortfall": "short by {shortfall}",
  "match.result.infeasibleMet": "{met} of {target} met",
  "match.result.infeasibleOvershoot": "{over} over the limit of {target}",
  "match.result.unlockMembers": "Unlock members",
  "match.result.infeasibleHeading": "The Solver couldn't compose a team that satisfies all requirements.",
  "match.result.infeasibleTitle": "No solution found",
  "match.result.insights.aiCriterionCandidates": "{count} candidates",
  "match.result.insights.aiMetShort": "{count} of them matched via AI",
  "match.result.insights.aiReasons": "{count} AI Reasons",
  "match.result.insights.aiShare": "AI share",
  "match.result.insights.bottlenecks": "Top 3 bottlenecks",
  "match.result.insights.radius": "Radius",
  "match.result.insights.radiusTitle": "{radius} km around {city}",
  "match.result.insights.radiusMapAria": "Radius map: candidates by distance to {city}",
  "match.result.insights.radiusInside": "{count} inside",
  "match.result.insights.radiusOutside": "{count} outside",
  "match.result.insights.radiusMissing": "{count} without distance",
  "match.result.insights.radiusHint": "Angle schematic, compressed distance scale",
  "match.result.insights.failCount": "{failed}/{total} excluded",
  "match.result.insights.fulfilledShort": "{met}/{total} fulfilled",
  "match.result.insights.gapShort": "{value} gap",
  "match.result.insights.hardestMust": "Knockout criterion",
  "match.result.insights.header": "Match analysis",
  "match.result.insights.koPassing": "meet it",
  "match.result.insights.noAiReasons": "No AI Reasons.",
  "match.result.insights.noBottleneck": "No notable bottlenecks.",
  "match.result.insights.noExclusion": "No must criterion excludes anyone.",
  "match.result.insights.noFulfilled": "No criterion is fulfilled.",
  "match.result.insights.averageShort": "avg {value}",
  "match.result.insights.medianShort": "median {value}",
  "match.result.insights.requiredShort": "target {value}",
  "match.result.insights.sdShort": "SD {value}",
  "match.result.insights.personDetailsInfoAria": "Show person details note",
  "match.result.insights.personDetailsInfoBody": "Person details are not shown as analysis distributions. They remain visible in the candidate detail.",
  "match.result.insights.personDetailsInfoTitle": "Person details",
  "match.result.insights.reasonsShort": "{count} Reasons",
  "match.result.insights.recommendAi": "Manually review {count} AI Reasons across {candidates} candidates.",
  "match.result.insights.recommendBottleneck": "{criterion} is the strongest bottleneck; avg fulfilment {average}.",
  "match.result.insights.recommendData": "Fill profile values for {criterion}; {missing}/{total} evidence values are missing.",
  "match.result.insights.recommendMust": "Review or relax {criterion}; this must criterion excludes {failed}/{total} candidates.",
  "match.result.insights.recommendNone": "No immediate adjustment needed.",
  "match.result.insights.recommendation": "Recommendation",
  "match.result.insights.textDistribution": "top value {value} ({count}/{present}) · {distinct} variants",
  "match.result.insights.topFulfilled": "Top 3 fulfilled criteria",
  "match.result.insights.unknownShort": "{count} not assessable",
  "match.result.loadFailed": "Result could not be loaded (id {id}). Check the browser console.",
  "match.result.memberCharacter": "Character",
  "match.result.memberCriteriaLess": "show fewer",
  "match.result.memberCriteriaMore": "show all {n}",
  "match.result.memberCoverage": "{met} of {total}",
  "match.result.memberCoverageVsMedian": "{met} of {total} · team median {median, number}",
  "match.result.memberOpenProfile": "Profile",
  "match.result.memberNoPowers": "No power assessment on file. This person counts in none of the team’s power averages – their contribution above rests on the requirements alone.",
  "match.result.memberPowerFit": "Power fit {n}",
  "match.result.memberPowerFitInfoAria": "Show explanation of this person’s power fit",
  "match.result.memberPowerFitInfoBody": "The person's own powers (0–100), weighted by the Powers Scorecard. High means they are strong exactly where the weight sits – independent of how they compare to the team.",
  "match.result.memberPowersRelative": "Powers vs. the team",
  "match.result.memberCriterionUnrated": "not rateable",
  "match.result.memberCriterionPartial": "partially met",
  "match.result.memberCriterionOpen": "not met",
  "match.result.memberCriterionMet": "met",
  "match.result.memberAnchorSole": "{name} (alone)",
  "match.result.memberAnchors": "Carries: {list}",
  "match.result.memberRequirements": "Requirements",
  "match.result.memberCriticalTag": "critical",
  "match.result.memberSummaryCriticalMust": "Without this person the must {count, plural, one {criterion} other {criteria}} {list} {count, plural, one {fails} other {fail}}.",
  "match.result.memberSummaryNoCoverage": "Meets no requirement – the contribution lies in the powers, not in the specialist criteria.",
  "match.result.memberSummaryNoCoverageNoPowers": "Meets no requirement – and with no power assessment on file, nothing else is known about the contribution.",
  "match.result.memberSummaryTopCoverage": "Covers the most requirements in the team.",
  "match.result.memberSummaryTopPowerFit": "Highest power fit in the team.",
  "match.result.memberSummaryCritical": "Critical for {list}.",
  "match.result.memberSummaryExclusiveSkills": "Only one with {list}{rest, plural, =0 {} other { and # more}} at a strong level.",
  "match.result.memberWhy": "Why in the team",
  "match.result.memberWhySuited": "Why suitable",
  "match.result.noRequirementsEmpty": "This match definition has no requirements – the requirements matrix stays empty.",
  "match.result.openFlag": "open",
  "match.result.openProfileTitle": "{name} – open profile",
  "match.result.powers.reqBadge": "Contributes to {met} of {total} power requirements",
  "match.result.powers.memberBadge": "Mean of this person's 30 powers (0–100)",
  "match.result.powers.memberBadgeUnmeasured": "No powers data – not counted in any average",
  "match.result.powers.expandClusterAria": "Expand {cluster} – show individual powers",
  "match.result.powers.collapseClusterAria": "Collapse {cluster}",
  "match.result.radarActual": "Team · raw",
  "match.result.radarActualPerson": "Person · raw",
  "match.result.radarScopeCluster": "Clusters",
  "match.result.radarScopeElement": "All {count} powers",
  "match.result.radarTarget": "Powers Scorecard",
  "match.result.radarTitleActual": "Actual",
  "match.result.radarTitleUnmeasured": "{count, plural, =0 {nobody on the team assessed} one {only # person assessed} other {only # people assessed}}",
  "match.result.radarTitleUnmeasuredPerson": "not assessed",
  "match.result.radarTitleWish": "Weighting",
  "match.result.ranking.aiChip": "AI Reason",
  "match.result.ranking.aiChipTitle": "Reason from the AI evaluation",
  "match.result.ranking.assessment.fazit": "Verdict",
  "match.result.ranking.assessment.negative": "Negative",
  "match.result.ranking.assessment.positive": "Positive",
  "match.result.ranking.assessment.title": "Smycles assessment",
  "match.result.ranking.collapseAll": "Collapse all",
  "match.result.ranking.expandAll": "Expand all",
  "match.result.ranking.kindBasics": "Person Details",
  "match.result.ranking.kindCertificate": "Certificate",
  "match.result.ranking.kindEducation": "Education",
  "match.result.ranking.kindExperience": "Experience",
  "match.result.ranking.kindExpertise": "Expertise",
  "match.result.ranking.kindLanguage": "Language",
  "match.result.ranking.kindPowers": "Powers",
  "match.result.ranking.lenientMatchHint": "Fulfilled via lenient requirement check: expertise present, required level not verified.",
  "match.result.ranking.dotUnknown": "Needs review",
  "match.result.ranking.dotFulfilled": "Fulfilled",
  "match.result.ranking.dotPartial": "Partially fulfilled",
  "match.result.ranking.dotUnfulfilled": "Not fulfilled",
  "match.result.ranking.emptyHintLabel": "Note",
  "match.result.ranking.emptyFilteredTab": "No {requirement} criteria under “{tab}”.",
  "match.result.ranking.emptyShowAll": "Show all criteria",
  "match.result.ranking.emptySwitchTab": "Switch to “{tab}”",
  "match.result.ranking.emptyTab": "There are no criteria under “{tab}”.",
  "match.result.ranking.tabNameFulfilled": "Fulfilled",
  "match.result.ranking.tabNameLenient": "Leniently fulfilled",
  "match.result.ranking.tabNameUnknown": "Needs review",
  "match.result.ranking.tabNameUnfulfilled": "Not fulfilled",
  "match.result.ranking.lenientTab": "Leniently fulfilled ({count})",
  "match.result.ranking.must": "Must",
  "match.result.ranking.kpiSmycles": "Smycles Score",
  "match.result.ranking.kpiPowerFit": "Power-Fit",
  "match.result.ranking.mustTitle": "Must criteria",
  "match.result.ranking.mustNone": "No must criteria",
  "match.result.ranking.mustInfoTitle": "Must criteria",
  "match.result.ranking.mustInfoAria": "Show must criteria",
  "match.result.ranking.mustFormula": "Must criteria are hard gates: every one has to be met.",
  "match.result.ranking.mustMetSummary": "Met: {met}/{total}",
  "match.result.ranking.criterionMet": "met",
  "match.result.ranking.criterionFailed": "not met",
  "match.result.ranking.kannTitle": "Optional criteria",
  "match.result.ranking.scoreCriteriaValue": "Optional criteria: {criteria}",
  "match.result.ranking.filterAll": "All",
  "match.result.ranking.filterMust": "Must",
  "match.result.ranking.filterKann": "Optional",
  "match.result.ranking.sortSmycles": "Smycles",
  "match.result.ranking.powerFitClusterCompare": "Clusters compared",
  "match.result.ranking.powerFitClusterCompareExplainer": "This person's cluster values against the average across all candidates in this ranking.",
  "match.result.ranking.powerFitPoolCompareSummary": "{above} of {total} clusters above the average across all candidates",
  "match.result.ranking.powerFitRadarExplainer": "This person's actual profile against the match's Powers Scorecard.",
  "match.result.ranking.powerFitTiltsExplainer": "Where this person sits between the two poles of each axis.",
  "match.result.ranking.powerFitTiltsHeading": "Tilt",
  "match.result.ranking.noAssessment": "No Smycles assessment available.",
  "match.result.ranking.noCriteria": "No criteria defined",
  "match.result.ranking.noMustHint": "Candidates end up here when they miss a must criterion (lock) or their score falls below the C threshold.",
  "match.result.ranking.notRated": "Present · level not rated",
  "match.result.ranking.openProfile": "Open profile",
  "match.result.ranking.optional": "Optional",
  "match.result.ranking.powerFitTooltip": "Power-Fit: weighted average of this person's own power values.",
  "match.result.ranking.review": "Needs review",
  "match.result.ranking.reviewHint": "Candidates end up here when a criterion could not be assessed, for example an expertise without a rated level. They have not failed, they need a look.",
  "match.result.ranking.reviewReasonBoth": "Must and optional not assessable",
  "match.result.ranking.reviewReasonKann": "Optional criteria not assessable",
  "match.result.ranking.reviewReasonMust": "Must criterion not assessable",
  "match.result.ranking.scoreCoverage": "{assessable} of {defined} criteria assessable",
  "match.result.ranking.scoreFormula": "Score = average of the optional (Kann) criteria.",
  "match.result.ranking.scoreInfoAria": "Show score calculation",
  "match.result.ranking.scoreInfoTitle": "Calculation",
  "match.result.ranking.scoreMustGate": "Must criteria remain a hard gate on top.",
  "match.result.ranking.scoreNotAssessable": "Optional criteria: not assessable",
  "match.result.ranking.sortBy": "Sort by",
  "match.result.ranking.sortPower": "Power-Fit",
  "match.result.ranking.sortRequirements": "Requirements-Fit",
  "match.result.ranking.thresholdAAria": "Threshold between A and B",
  "match.result.ranking.thresholdBAria": "Threshold between B and C",
  "match.result.ranking.thresholdCAria": "Lower bound for C",
  "match.result.ranking.thresholdsLabel": "Thresholds",
  "match.result.ranking.unknownTab": "Needs review ({count})",
  "match.result.ranking.unqualified": "Criteria not met",
  "match.result.ranking.yearsValue": "{years, plural, one {# year} other {# years}}",
  "match.result.rankingHeader": "Ranking",
  "match.result.reviewSubtitle": "Optimized for your requirement profile – transparent, explainable, exportable.",
  "match.result.saveResult": "Save result",
  "match.result.savedResultLabel": "Saved result · {name}",
  "match.result.savedSubtitle": "You're viewing a saved result of this Match.",
  "match.result.skillMaxLevel": "up to {level}",
  "match.result.skillRequested": "Requirement",
  "match.result.skillStrongOfTeam": "{n} of {total} strong",
  "match.result.skillTotalAtAll": "{n} at all",
  "match.result.solverErrorBody": "Genesis rejected the calculation. This currently happens when the match design contains fields the backend doesn't (yet) know. Try again shortly or report the case with the correlation ID below.",
  "match.validationRejected": "Genesis rejected the request.",
  "match.result.solverErrorHeading": "The backend didn't finish the Solver.",
  "match.result.solverErrorTitle": "Solver error",
  "match.result.solverNotRun": "Solver hasn't run yet.",
  "match.result.skillMatrix": "Skills matrix",
  "match.result.skillMatrixUnrated": "present, no level rated",
  "match.result.skillMatrixFocusSkill": "Skill focus",
  "match.result.skillMatrixFocusTeam": "Team focus",
  "match.result.skillStrongHint": "strong from {level}",
  "match.result.skillStructureHeader": "Top Skills",
  "match.result.solverRunning": "Solver running …",
  "match.result.tilt.axis.DRIVE": "Drive ↔ attraction",
  "match.result.tilt.axis.MINDSET": "Exploit ↔ explore",
  "match.result.tilt.balanced": "balanced",
  "match.result.tilt.bothWeak": "weak on both sides",
  "match.result.tilt.infoAria": "Show explanation of the team axes",
  "match.result.tilt.info.DRIVE": "Share of powers above {threshold}: drive {a}%, attraction {b}%. Drive powers push from within, attraction powers create the conditions under which drive lands in a team. Compared as shares, because drive covers four clusters and attraction two.",
  "match.result.tilt.info.MINDSET": "Share of powers above {threshold}, within drive: exploit {a}%, explore {b}%. Exploit secures and optimises the existing, explore opens what is possible. Teams that combine both are more capable than one-sided ones.",
  "match.result.tilt.grade.CLEAR": "clearly {side}",
  "match.result.tilt.grade.LEANS": "leans {side}",
  "match.result.tilt.grade.STRONG": "strongly {side}",
  "match.result.tilt.notSignificant": "Difference too small to read",
  "match.result.tilt.infoNoise": "The wording follows how far the difference clears its own sampling error: leans = beyond it, clearly = one and a half times, strongly = twice. Only these three steps are given: at this team size the exact difference is not dependable enough to read as a number.",
  "match.result.tilt.side.EXPLOIT": "Exploit",
  "match.result.tilt.side.EXPLORE": "Explore",
  "match.result.tilt.side.PULL": "Attraction",
  "match.result.tilt.side.PUSH": "Drive",
  "match.result.structureBoosters": "Booster coverage",
  "match.result.structureBoostersHint": "Boosters are the powers with the highest innovation relevance. A thinly covered row is the team’s concrete gap.",
  "match.result.memberClusterCountInfoAria": "Show explanation of the count and the distance",
  "match.result.memberClusterCountInfoBody": "Count: how many of this person's 5 cluster powers are above {threshold} – a mean of 68 can be five times 68 or one strong power beside four weak ones. Bar: it sits on the team's cluster mean – to the right the person lifts the team here, to the left they sit below it. Last, their own cluster mean.",
  "match.result.memberClusterCountInfoTitle": "Count and distance",
  "match.result.structureBoostersInfoAria": "Show explanation of booster coverage",
  "match.result.structureBoostersInfoBody": "Shown is how many of the assessed people bring the power strongly (above {threshold}). Such a gap can be closed by re-staffing or developed deliberately.",
  "match.result.structureBoostersInfoTitle": "Boosters and gaps",
  "match.result.structureCarriersInfoAria": "Show explanation of the counting",
  "match.result.structureCarriersInfoBody": "The count is over people with powers data, not the whole team: “2 of 6” means two carriers among six assessed people.",
  "match.result.structureCarriersInfoTitle": "What is counted",
  "match.result.structureCarriers": "Cluster carriers",
  "match.result.structureCarriersHint": "Carrier = at least {min} of the cluster’s 5 powers above {threshold}; complete = all 5 above it.",
  "match.result.structureHeader": "Powers profile structure",
  "match.result.structureOfTeam": "{n} of {total}",
  "match.result.structureSignature": "· {n} complete",
  "match.result.structureThresholdHint": "powers above {threshold}",
  "match.result.teamHeader": "Team · {count, plural, one {# person} other {# people}}",
  "match.result.teamPowers": "Power Scorecard matrix",
  "match.result.teamSizeMeta": "Team size {count}",
  "match.result.unnamed": "unnamed",
  "match.result.weightedPowersInfoAria": "Show explanation of this list",
  "match.result.weightedPowersInfoBody": "All 30 powers of the team, sortable by team score or by weighting. Weighting: the 0–10 value from the Powers Scorecard that steered the selection. Ø: the team's mean for this power, 0–100.",
  "match.result.weightedPowersInfoTitle": "What this shows",
  "match.result.weightedPowersSoleHint": "„only …“ means: the only person who brings this power strongly.",
  "match.save.eyebrow": "Save result",
  "match.save.failed": "Save failed",
  "match.save.modeAssess": "Assess",
  "match.save.modeOptimize": "Optimize",
  "match.save.modeRank": "Rank",
  "match.save.note": "Note",
  "match.save.notePlaceholder": "Optional – context, assumptions, next steps …",
  "match.save.off": "off",
  "match.save.on": "on",
  "match.save.previewAndNote": "Preview & note",
  "match.save.resultName": "Result name",
  "match.save.retry": "Try again",
  "match.save.saved": "Saved",
  "match.save.saving": "Saving…",
  "match.save.statAgenticAi": "Agentic AI",
  "match.save.statConditions": "Conditions",
  "match.save.statMode": "Mode",
  "match.save.statPool": "Pool",
  "match.save.statTarget": "Target",
  "match.save.teamCount": "Team · {count, plural, one {# person} other {# people}}",
  "match.settingsEyebrow": "Match settings",
  "match.shortDescPlaceholder": "In one sentence: what, what for?",
  "match.step.challenge": "Challenge",
  "match.step.people": "Team players",
  "match.step.peopleRank": "Candidates",
  "match.step.result": "Result",
  "match.teamPowers": "Power Scorecard",
  "match.teamProfile": "Selection",
  "match.teamProfileCustom": "Custom",
  "match.teamProfileModifiedSuffix": " · modified",
  "match.roleReqsSection": "Role requirements",
  "match.teamReqsSection": "Team requirements",
  "match.teamSizeSection": "Team size",
  "match.titlePlaceholder": "e.g. Set crew BTL · Q2 2026",
  "match.tour.create.desc": "This button creates a new match and opens the editor, where you describe what you need and the solver proposes the team.",
  "match.tour.create.title": "Create a new match",
  "match.tour.label": "Match",
  "match.tour.list.desc": "All your matches live here. Click a card to reopen it and continue where you left off.{names}",
  "match.tour.list.names": "Currently: {list}.",
  "match.tour.list.title": "Your matches",
  "match.tour.summary": "This is the Match area: you put teams together from people and requirements. You have {count} matches so far.",
  "match.unnamedMatch": "Unnamed match",
  "match.unnamedProject": "Unnamed project",
  "match.weightLevel.high": "High",
  "match.weightLevel.low": "Low",
  "match.weightLevel.medium": "Medium",
  "match.weightLevel.none": "Not relevant",
  "match.workflow.challengeSubtitle": "Describe your project above – the AI derives team size, requirements and powers from it. Below you review the result and fine-tune small details.",
  "match.workflow.challengeSubtitleNoTeamSize": "Describe your project above – the AI derives requirements and powers from it. Below you review the result and fine-tune small details.",
  "match.workflow.challengeSubtitleRank": "Describe the role or open position above – the AI derives the requirements a candidate should meet. Below you review the result and fine-tune small details.",
  "match.workflow.deleteConfirm.confirm": "Delete",
  "match.workflow.deleteConfirm.message": "The Match will be permanently removed from genesis. This action cannot be undone.",
  "match.workflow.deleteConfirm.title": "Delete Match?",
  "match.workflow.deleteTitle": "Delete match",
  "match.workflow.modeAssess": "Assess",
  "match.workflow.modeIndicatorTitle": "Mode (fixed at creation)",
  "match.workflow.modeOptimize": "Optimize",
  "match.workflow.modeRank": "Rank",
  "match.workflow.nextTo": "Continue to {label}",
  "match.workflow.prevTo": "Back to {label}",
  "match.workflow.settingsTitle": "Match settings",
  "matchDetail.tour.label": "Match Detail",
  "matchDetail.tour.summary": "You are editing the match \"{name}\", currently on the \"{step}\" workflow step with {candidates} candidates and {results} saved results. Work through the steps from requirements to the solved team.",
  "matchDetail.tour.untitled": "untitled match",
  "model.connected": "Connected",
  "model.docs.title": "Knowledge documents",
  "model.docs.sub": "Documents the assistant can search. Uploads are processed in the background.",
  "model.docs.dropLabel": "Drop a document or click to choose",
  "model.docs.dropHint": "PDF, Word, PowerPoint, and more, up to 50 MB",
  "model.docs.titlePlaceholder": "Title (required)",
  "model.docs.titleLabel": "Document title",
  "model.docs.descPlaceholder": "What it's about (optional)",
  "model.docs.descLabel": "Document description",
  "model.docs.upload": "Upload and process ({provider})",
  "model.docs.duplicate": "That document is already uploaded.",
  "model.docs.uploadError": "Upload failed – try again.",
  "model.docs.loadError": "Couldn't load documents.",
  "model.docs.empty": "No documents yet.",
  "model.docs.unavailableHint": "Not embedded for the current provider. Re-embed to make it searchable.",
  "model.docs.status.reembedRequired": "New processing required ({provider})",
  "model.docs.status.processingFor": "Processing ({provider})",
  "model.docs.worksWith": "Works with this provider",
  "model.docs.textOnly": "Text only",
  "model.docs.textOnlyHint": "Skip images for faster processing; text stays searchable.",
  "model.docs.textOnlyForced": "Images can't be extracted from this file type; it will be indexed as text.",
  "model.docs.enabledLabel": "Enabled",
  "model.docs.download": "Download",
  "model.docs.reprocess": "Reprocess",
  "model.docs.delete": "Delete",
  "model.docs.deleteTitle": "Delete document?",
  "model.docs.deleteMessage": "“{title}” and its extracted content will be removed.",
  "model.docs.sectionUploaded": "Uploaded documents",
  "model.docs.sectionGlobal": "Global documents",
  "model.docs.uploadedAt": "Uploaded {date}",
  "model.docs.failedHint": "Processing failed. Try reprocessing, or re-upload the document.",
  "model.docs.cancel": "Cancel",
  "model.docs.cancelTitle": "Cancel processing?",
  "model.docs.cancelMessage": "“{title}” will stop processing and be removed.",
  "model.docs.cancelKeep": "Keep processing",
  "model.docs.cancelReprocessTitle": "Stop reprocessing?",
  "model.docs.cancelReprocessMessage": "“{title}” is left unchanged. The processing in progress is discarded.",
  "model.docs.cancelReprocessConfirm": "Stop reprocessing",
  "model.docs.uploadBlocked": "Waiting for the provider switch to take effect… ({seconds}s)",
  "model.docs.needFile": "Choose a document to upload.",
  "model.docs.needTitle": "Add a title.",
  "model.docs.needSections": "Select at least one section.",
  "model.docs.status.pending": "Pending",
  "model.docs.status.processing": "Processing",
  "model.docs.status.ready": "Ready",
  "model.docs.status.failed": "Failed",
  "model.keyAriaLabel": "{provider} API key",
  "model.providerSub": "The upstream model stack. Model kinds resolve to this provider's concrete models.",
  "model.providerSwitchHint": "Switching to {provider} changes the embedding model ({from} → {to}). It may be necessary to reprocess the documents again after saving so they stay searchable.",
  "model.providerTitle": "Provider",
  "model.resolvedModels": "Resolved models",
  "model.saveError": "Couldn't save model settings – try again.",
  "model.saveError.forbidden": "You need admin rights to change the model configuration.",
  "model.saveError.notConfigured": "Model configuration isn't enabled on this server.",
  "model.saveError.unauthorized": "Your session has expired – sign in again.",
  "model.saveError.upstream": "Couldn't reach the configuration store – try again.",
  "model.saved": "Settings saved – may take up to 30 seconds to take effect.",
  "nav.community": "Community",
  "nav.inviteOutsider": "Invite external person",
  "nav.logout": "Logout",
  "nav.mainLandmark": "Main",
  "nav.map": "Map",
  "nav.openMenu": "Open menu",
  "nav.pins": "Pins",
  "nav.play": "Play",
  "nav.profile": "Profile",
  "nav.service": "Documents",
  "nav.settings": "Settings",
  "nav.watch": "Watch",
  "personFilter.addFilter": "+ Add filter",
  "personFilter.allFilters": "All filters",
  "personFilter.frequent": "Frequent",
  "personFilter.heading": "Team Player filters{count, plural, =0 {} other { · # active}}",
  "pinboard.tour.controls.desc": "Search pins by name, change the sort order, or filter to pins that are not in any group yet.",
  "pinboard.tour.controls.title": "Search & sort",
  "pinboard.tour.grid.desc": "{count} {typeLabel} in the current view. Click a card to open it, use \"+ Add\" to put it into groups, or the trash icon to unpin it.",
  "pinboard.tour.grid.title": "Your pinned items",
  "pinboard.tour.label": "Save Pins",
  "pinboard.tour.sidebar.desc": "Switch between your pinned people ({people}), posts ({posts}) and projects ({projects}), and pick a pin group below. Drag a card onto a group to file it there.",
  "pinboard.tour.sidebar.title": "Types & groups",
  "pinboard.tour.summary": "This is your pinboard with everything you saved: {people} people, {posts} posts and {projects} projects.",
  "power.name.Abs": "Abstraction",
  "power.name.Ada": "Adaption",
  "power.name.Agg": "Aggression",
  "power.name.Aut": "Autonomy",
  "power.name.Awe": "Self-Perception",
  "power.name.Cha": "Charisma",
  "power.name.Con": "Concentration",
  "power.name.Cop": "Tolerance",
  "power.name.Cou": "Courage",
  "power.name.Cur": "Curiosity",
  "power.name.Dil": "Diligence",
  "power.name.Emp": "Empathy",
  "power.name.Exp": "Expression",
  "power.name.Fai": "Belief",
  "power.name.Fid": "Fidelity",
  "power.name.Fns": "Fairness",
  "power.name.Hum": "Humor",
  "power.name.Ima": "Imagination",
  "power.name.Imp": "Improvisation",
  "power.name.Ins": "Inspiration",
  "power.name.Int": "Intention",
  "power.name.Inu": "Intuition",
  "power.name.Joy": "Joy",
  "power.name.Lan": "Language",
  "power.name.Min": "Mindfulness",
  "power.name.Pas": "Passion",
  "power.name.Per": "Perception",
  "power.name.Psc": "Perseverance",
  "power.name.Rpy": "Responsibility",
  "power.name.Str": "Strategy",
  "power.tag.Co": "Communication",
  "power.tag.Co.description": "Capturing and conveying. These Powers turn inner experience into shared perception, language, and expression.",
  "power.tag.Fo": "Future Orientation",
  "power.tag.Fo.description": "Direction toward the uncertain. These Powers give the team the strength to think beyond what exists and move into the open.",
  "power.tag.In": "Inventiveness",
  "power.tag.In.description": "Unlocking the new. These Powers open the space beyond the known and keep the team capable of learning.",
  "power.tag.Re": "Resilience",
  "power.tag.Re.description": "Stability under load. These Powers keep the team capable of acting as pressure, duration, and resistance increase.",
  "power.tag.Ro": "Result Orientation",
  "power.tag.Ro.description": "Commitment to outcome. These Powers turn intent into reliably completed, effective work.",
  "power.tag.Ts": "Teamability",
  "power.tag.Ts.description": "The glue of community. These Powers turn individuals into a resilient, diverse, and sustainable whole.",
  "profile.fields.addCountry": "+ Country",
  "profile.fields.avatarAlt": "Avatar",
  "profile.fields.changePhoto": "Change photo",
  "profile.fields.removePhoto": "Remove photo",
  "profile.page.add.certificate": "Add certificate",
  "profile.page.add.education": "Add education",
  "profile.page.add.experience": "Add work experience",
  "profile.page.add.expertise": "Add skill",
  "profile.page.add.language": "Add language",
  "profile.page.addToCommunity": "Community",
  "profile.page.addToPins": "Pins",
  "profile.page.ageSuffix": "{age} years",
  "profile.page.avatar.tooLarge": "Choose an image of {max} MB or less.",
  "profile.page.avatar.notAnImage": "Choose an image file.",
  "profile.page.avatar.notReadable": "That file could not be read as an image.",
  "profile.page.avatar.tooManyPixels": "This image is too large to crop. Use one under {max} megapixels.",
  "profile.page.allLabel": "All:",
  "profile.page.businessCard": "Business card",
  "profile.page.businessCardRoleHint": "Taken from Details › Company › Job title",
  "profile.page.details": "Details",
  "profile.page.details.company": "Company",
  "profile.page.details.personal": "Personal",
  "profile.page.editVisibility": "Edit visibility",
  "profile.page.empty.certificates": "No certificates",
  "profile.page.empty.education": "No education",
  "profile.page.empty.experience": "No work experience",
  "profile.page.empty.expertise": "No skills",
  "profile.page.empty.languages": "No languages",
  "profile.page.error.certificateNameRequired": "Name is required.",
  "profile.page.error.fieldOfStudyRequired": "Field of study is required.",
  "profile.page.error.jobTitleRequired": "Job title is required.",
  "profile.page.error.languageLevelRequired": "Please choose a level for the foreign language.",
  "profile.page.error.nameRequired": "First name and last name are required.",
  "profile.page.error.invalidFields": "{count, plural, one {One field needs attention} other {# fields need attention}} before saving.",
  "profile.page.error.saveEntries": "Could not save entries",
  "profile.page.error.saveEntriesFailedCount": "{count, plural, one {# entry could not be saved.} other {# entries could not be saved.}}",
  "profile.page.error.saveFailed": "Saving failed.",
  "profile.page.error.saveCertificate": "Could not save the certificate",
  "profile.page.error.saveEducation": "Could not save the education entry",
  "profile.page.error.saveExperience": "Could not save the experience",
  "profile.page.error.saveLanguage": "Could not save the language",
  "profile.page.error.saveSkill": "Could not save the skill",
  "profile.page.error.savePerson": "Could not save person",
  "profile.page.error.skillNameRequired": "A name is required.",
  "profile.page.error.tooManyActivities": "Keep this to {max} entries or fewer.",
  "profile.page.error.startDateRequired": "Start date is required.",
  "profile.page.familyName.placeholder": "Last name",
  "profile.page.field.activities.label": "Main tasks",
  "profile.page.field.activities.placeholder": "e.g. Code reviews",
  "profile.page.field.activities.counter": "{count} of {max}",
  "profile.page.field.cefr": "Level (CEFR)",
  "profile.page.field.certificateName.label": "Name",
  "profile.page.field.certificateName.placeholder": "e.g. AWS Solutions Architect",
  "profile.page.field.country": "Country",
  "profile.page.field.degree.label": "Degree",
  "profile.page.field.degree.placeholder": "Choose degree",
  "profile.page.field.degree.search": "Search degree",
  "profile.page.field.degree.none": "No degree selected",
  "profile.page.field.department": "Department",
  "profile.page.field.employer.label": "Employer",
  "profile.page.field.employer.placeholder": "e.g. Smycles GmbH",
  "profile.page.field.expertiseName.label": "Name",
  "profile.page.field.expertiseName.placeholder": "e.g. Kubernetes",
  "profile.page.field.field.label": "Field of study",
  "profile.page.field.field.placeholder": "e.g. Computer science",
  "profile.page.field.from": "From",
  "profile.page.field.industry": "Industry",
  "profile.page.field.institution": "Educational institution",
  "profile.page.field.issueDate": "Issue date",
  "profile.page.field.jobTitle.label": "Job title",
  "profile.page.field.jobTitle.placeholder": "e.g. Software developer",
  "profile.page.field.language.label": "Language",
  "profile.page.field.language.placeholder": "Choose language",
  "profile.page.field.level": "Level",
  "profile.page.field.location": "Location",
  "profile.page.field.nativeSpeaker.label": "Native language",
  "profile.page.field.nativeSpeaker.placeholder": "Native language",
  "profile.page.field.to": "To",
  "profile.page.givenName.placeholder": "First name",
  "profile.page.hideVisibility": "Hide visibility",
  "profile.page.inCommunity": "In community",
  "profile.page.inPins": "In pins",
  "profile.page.label.apartment": "Apartment",
  "profile.page.label.birthday": "Birthday",
  "profile.page.label.childCount": "Number of children",
  "profile.page.label.citizenship": "Citizenship",
  "profile.page.label.city": "Place of residence",
  "profile.page.label.contractType": "Contract type",
  "profile.page.label.country": "Country",
  "profile.page.label.countryState": "State / region",
  "profile.page.label.currentActivity": "Current activity",
  "profile.page.label.currentEmployer": "Employer",
  "profile.page.label.currentTasks": "Main tasks",
  "profile.page.label.drivingLicence": "Driving licence",
  "profile.page.label.email": "Email",
  "profile.page.label.gender": "Gender",
  "profile.page.label.houseNumber": "House number",
  "profile.page.label.jobDepartment": "Department",
  "profile.page.label.jobLocation": "Work location",
  "profile.page.label.jobTitle": "Job title",
  "profile.page.label.maritalStatus": "Marital status",
  "profile.page.label.miscellaneous": "Other",
  "profile.page.label.nationality": "Nationality",
  "profile.page.label.phone": "Phone",
  "profile.page.label.profession": "Profession",
  "profile.page.label.street": "Street",
  "profile.page.label.website": "Website",
  "profile.page.label.workingTimeModel": "Working time",
  "profile.page.label.zipCode": "Postal code",
  "profile.page.loadFailed": "Profile could not be loaded",
  "profile.page.loadFailedHint": "Please reload the page or sign in again.",
  "profile.page.notFound": "Profile not found",
  "profile.page.notFoundHint": "This profile does not exist or has not been shared with you.",
  "profile.page.openChat": "Open chat",
  "profile.page.section.certificates": "Certificates",
  "profile.page.section.education": "Education",
  "profile.page.section.experience": "Work experience",
  "profile.page.section.expertise": "Expertise",
  "profile.page.section.languages": "Languages",
  "profile.page.serviceMenu": "Service",
  "profile.page.startChat": "Send message",
  "profile.page.summary": "Summary",
  "profile.rows.done": "Done",
  "profile.rows.level": "Level: {level}",
  "profile.rows.nativeSpeaker": "Native speaker",
  "profile.rows.noLevel": "No level",
  "profile.rows.today": "today",
  "profile.sidebars.closeCluster": "Close",
  "profile.sidebars.combined": "Combined",
  "profile.sidebars.errorPrefix": "Error: {message}",
  "profile.sidebars.loading": "loading…",
  "profile.sidebars.noEvaluation": "Not yet assessed.",
  "profile.sidebars.openClusterFor": "Show evaluation for {power}",
  "profile.sidebars.powerMap": "Power Map",
  "profile.sidebars.powersNotAssessed": "This person has not been assessed yet.",
  "profile.sidebars.powersNotShared": "This person has not shared their powers.",
  "profile.sidebars.powersTitle": "Powers",
  "profile.sidebars.selfAssessment": "Self-assessment",
  "profile.sidebars.smartAnalysis": "Smart analysis",
  "profile.skills.addAtLevel": "Add skill at this level",
  "profile.skills.unrated": "Unrated",
  "profile.skills.viewDiagram": "Modern",
  "profile.skills.viewList": "Classic",
  "profile.tour.about.desc": "Your summary text, your personal and company details and your {languages} languages. Click any field to edit it in place.",
  "profile.tour.about.title": "Summary, details and languages",
  "profile.tour.card.desc": "Click any field (name, phone, email, country, city) to edit it in place; changes are collected and saved via the save bar.{missing}",
  "profile.tour.card.missingHint": "Some of your contact fields are still empty.",
  "profile.tour.card.title": "Your business card",
  "profile.tour.cv.desc": "{experiences} work experiences, {educations} educations, {skills} skills and {certificates} certificates. Add new entries here or click an existing one to edit it.",
  "profile.tour.cv.title": "Your CV entries",
  "profile.tour.label": "Save Profile",
  "profile.tour.powers.desc": "Your strongest powers at a glance. Click one to see its detail page, or assess more of them over in Grow.",
  "profile.tour.powers.title": "Your powers",
  "profile.tour.service.desc": "AI helpers and data services for your profile: extract powers and skills, import a CV or LinkedIn profile, generate a CV and export your data.",
  "profile.tour.service.title": "Service menu",
  "profile.tour.summary": "This is your own profile with {count} CV entries. Almost every field is editable right on the page.",
  "profile.tour.visibility.desc": "This toggle reveals a share switch next to every field and entry, so you decide exactly what other people can see of your profile.",
  "profile.tour.visibility.title": "Edit visibility",
  "profileExtraction.abort": "Abort extraction",
  "profileExtraction.abortTip": "Still extracting - you can keep waiting, or abort and try again with the same document. Nothing has been saved yet.",
  "profileExtraction.analysing": "Extracting profile data from your document - this can take up to two minutes...",
  "profileExtraction.dropZone": "Drag a document here or click to upload",
  "profileExtraction.dropZoneHint": "CV, LinkedIn export, application form … · PDF, DOCX, image · max. 10 MB",
  "profileExtraction.elapsed": "Elapsed time: {time}",
  "profileExtraction.fileTooLarge": "File is too large (max. 10 MB).",
  "profileExtraction.noResult": "The document could not be analysed.",
  "profileExtraction.timeout": "Analysis is taking too long. Please try again.",
  "profileExtraction.nothingNew": "Nothing new found – your profile already covers this document.",
  "profileExtraction.ready": "We found details to review in {file}.",
  "profileExtraction.review": "Review changes",
  "profileExtraction.title": "CV Extractor",
  "profileExtraction.unsupportedType": "Unsupported file type.",
  "referenceData.add": "Add",
  "referenceData.cancel": "Cancel",
  "referenceData.confirmDelete.message": "The entry is removed for good and will no longer be offered in profiles and Match requirements.",
  "referenceData.confirmDelete.title": "Delete “{label}”?",
  "referenceData.contractType.add": "New contract type",
  "referenceData.contractType.empty": "No contract types yet.",
  "referenceData.contractType.sub": "Managed list of contract types.",
  "referenceData.contractType.title": "Contract types",
  "referenceData.degree.add": "New degree",
  "referenceData.degree.empty": "No degrees yet.",
  "referenceData.degree.sub": "Managed list of academic degrees for education entries.",
  "referenceData.degree.title": "Degrees",
  "referenceData.delete": "Delete",
  "referenceData.duplicate": "This entry already exists.",
  "referenceData.edit": "Edit",
  "referenceData.gender.add": "New gender",
  "referenceData.gender.empty": "No entries.",
  "referenceData.gender.sub": "Managed list of genders.",
  "referenceData.gender.title": "Genders",
  "referenceData.industry.add": "New industry",
  "referenceData.industry.empty": "No industries yet.",
  "referenceData.industry.sub": "Managed list of industries for profiles and Match requirements.",
  "referenceData.industry.title": "Industries",
  "referenceData.jobDepartment.add": "New department",
  "referenceData.jobDepartment.empty": "No departments yet.",
  "referenceData.jobDepartment.sub": "Managed list of departments for profiles and Match requirements.",
  "referenceData.jobDepartment.title": "Departments",
  "referenceData.jobLocation.add": "New work location",
  "referenceData.jobLocation.empty": "No work locations yet.",
  "referenceData.jobLocation.sub": "Managed list of work locations for profiles and Match requirements.",
  "referenceData.jobLocation.title": "Work locations",
  "referenceData.loading": "Loading…",
  "referenceData.maritalStatus.add": "New marital status",
  "referenceData.maritalStatus.empty": "No entries.",
  "referenceData.maritalStatus.sub": "Managed list of marital statuses.",
  "referenceData.maritalStatus.title": "Marital statuses",
  "referenceData.save": "Save",
  "referenceData.workingTimeModel.add": "New working-time model",
  "referenceData.workingTimeModel.empty": "No working-time models yet.",
  "referenceData.workingTimeModel.sub": "Managed list of working-time models.",
  "referenceData.workingTimeModel.title": "Working-time models",
  "save.addToCollection.adding": "Adding…",
  "save.addToCollection.doneInGroup": "<nm>{name}</nm> was added to <b>{target}</b> in <b>{group}</b>.",
  "save.addToCollection.doneNoGroup": "<nm>{name}</nm> was added to <b>{target}</b> (without group).",
  "save.addToCollection.error": "Could not add. Please try again.",
  "save.addToCollection.goToTarget": "To {target}",
  "save.addToCollection.groupLabel": "Group",
  "save.addToCollection.noGroupPlaceholder": "Without group",
  "save.addToCollection.personFallback": "Person",
  "save.addToCollection.title": "Add {name} to {target}",
  "save.careerGraph.active": "Active",
  "save.careerGraph.done": "Done",
  "save.careerGraph.emptyLabel": "No career or education entries",
  "save.careerGraph.mainTasks": "Main tasks",
  "save.careerGraph.modeGraph": "Modern",
  "save.careerGraph.modeList": "Classic",
  "save.careerGraph.showMainTasks": "Show main tasks",
  "save.careerGraph.title": "Career & Education",
  "save.careerGraph.today": "today",
  "save.careerGraph.todayMarker": "TODAY",
  "save.careerGraph.visibilityPrivate": "Private",
  "save.careerGraph.visibilityPublic": "Public",
  "save.careerGraph.visibilityShared": "Shared",
  "save.collection.addToGroup": "Add to „{name}”",
  "save.collection.allGroups": "All",
  "save.collection.allLabel": "All",
  "save.collection.deleteGroup": "Delete group",
  "save.collection.errorPrefix": "Error: {message}",
  "save.collection.nameLabel": "Name",
  "save.collection.openItem": "Open {title}",
  "save.collection.removeFromGroup": "Remove from „{name}”",
  "save.collection.rename": "Rename",
  "save.collection.renameGroup": "Rename group",
  "save.collection.searchPlaceholder": "Search…",
  "save.community.addCommunity": "+ Community",
  "save.community.addTrigger": "+ Add",
  "save.community.createError": "Community could not be created.",
  "save.community.dailyQuotaExceeded": "Daily limit reached. Please try again later.",
  "save.community.deleteCommunity": "Delete community",
  "save.community.deleteCompletely": "Delete completely",
  "save.community.deleteConfirm": "Delete \"{name}\"? The contacts are kept, only the grouping is removed.",
  "save.community.deleteContactPrompt": "Delete \"{name}\" from your contacts and all communities?",
  "save.community.deleteError": "Community could not be deleted.",
  "save.community.description": "Group your contacts. Select a community on the left and drag contacts into it or add them to one or more communities via \"Add\".",
  "save.community.emptyAllGrouped": "All contacts are in communities.",
  "save.community.emptyCommunity": "No one in this community yet. Drag contacts here or use \"Add\".",
  "save.community.emptyNoContacts": "No contacts yet.",
  "save.community.headerCount": "{count, plural, one {# contact} other {# contacts}}",
  "save.community.limitReached": "You have reached the maximum of {limit} communities.",
  "save.community.moveFailed": "Move failed.",
  "save.community.namePlaceholder": "Community name …",
  "save.community.newCommunity": "New community",
  "save.community.removeContact": "Remove contact",
  "save.community.removeContactError": "Contact could not be removed.",
  "save.community.removeFromCommunityFailed": "Removing from the community failed.",
  "save.community.removeFromCommunityPrompt": "Remove \"{name}\" from \"{community}\" (stays your contact and in other communities) or delete completely from your contacts and all communities?",
  "save.community.removeFromGroup": "Remove from group",
  "save.community.renameCommunity": "Rename community",
  "save.community.renameError": "Community could not be renamed.",
  "save.community.saveError": "Community could not be saved.",
  "save.community.title": "Community",
  "save.community.ungroupedLabel": "Contacts without a community",
  "save.extraction.analysing": "Analysing …",
  "save.extraction.analysisComplete": "Analysis complete.",
  "save.extraction.analysisFailed": "Analysis failed.",
  "save.extraction.analysisFailedWithReason": "Analysis failed ({reason}).",
  "save.extraction.done": "Done",
  "save.extraction.dropZone": "Drag a file here or click to upload",
  "save.extraction.dropZoneHint": "PDF, Word, Excel, images · max. 10 MB per file",
  "save.extraction.duplicateWarning": "Already exists in Documents - the stored document is analysed, no re-upload.",
  "save.extraction.expertiseFallback": "Expertise",
  "save.extraction.fileTooLarge": "“{name}” is too large (max. 10 MB per file).",
  "save.extraction.fromDocuments": "From Documents",
  "save.extraction.newFile": "New file",
  "save.extraction.newPowersHeading": "Newly detected powers{count, plural, =0 {} other { (#)}}",
  "save.extraction.newSkillsHeading": "Newly detected expertise{count, plural, =0 {} other { (#)}}",
  "save.extraction.loadingDocuments": "Loading documents …",
  "save.extraction.noAnalyzableDocuments": "None of your documents can be analysed.",
  "save.extraction.noDocuments": "No documents available.",
  "save.extraction.noFolder": "No folder",
  "save.extraction.noMatches": "No matches",
  "save.extraction.noNewPowers": "No changes - the analysis produced no new power values.",
  "save.extraction.noNewSkills": "No new entries - everything was probably already in your expertise.",
  "save.extraction.notSignedIn": "Not signed in - upload not possible.",
  "save.extraction.nothingSelected": "Nothing selected",
  "save.extraction.persistUploads": "Save uploaded files in Documents",
  "save.extraction.pipelineCounts": "{processed} processed · {skipped} skipped · {errored} errors",
  "save.extraction.poweredBy": "Powered by smycles AI",
  "save.extraction.powers": "Powers",
  "save.extraction.runningInBackground": "Running in the background - you can close this and keep working. You’ll be notified when it’s done.",
  "save.extraction.searchDocuments": "Search documents",
  "save.extraction.selectAllInGroup": "Select all in {group}",
  "save.extraction.selectedCount": "{total, plural, one {# document selected} other {# documents selected}}",
  "save.extraction.skills": "Skills",
  "save.extraction.startAnalysis": "Start analysis",
  "save.extraction.statusLine": "Status: {status}",
  "save.extraction.stillRunning": "The analysis is taking a while and keeps running in the background. You’ll get a notification when it’s done.",
  "save.extraction.toggleCollapse": "Expand/collapse",
  "save.extraction.unsupportedType": "“{name}” can’t be analysed. Supported: PDF, Word, Excel and images.",
  "save.extraction.uploadFailedDuplicate": "Upload failed. A document with this name probably already exists.",
  "save.pinGroupDialog.createFailed": "The group could not be created.",
  "save.pinGroupDialog.invalidName": "Invalid name.",
  "save.pinGroupDialog.limitReached": "You have reached the maximum of {limit} groups.",
  "save.pinGroupDialog.placeholder": "e.g. Mentors",
  "save.pinGroupDialog.renameFailed": "The group could not be renamed.",
  "save.pinGroupDialog.submitCreate": "Create",
  "save.pinGroupDialog.titleCreate": "New group",
  "save.pinGroupDialog.titleRename": "Rename group",
  "save.pinGroupDialog.tryAgain": "Please try again.",
  "save.pinGroupSidebar.addGroup": "+ Group",
  "save.pinGroupSidebar.deleteMessage": "Delete “{name}”? The pins remain, only the grouping is removed.",
  "save.pinGroupSidebar.deleteTitle": "Delete group",
  "save.pinGroupSidebar.tabPerson": "People",
  "save.pinGroupSidebar.tabPost": "Posts",
  "save.pinGroupSidebar.tabProject": "Projects",
  "save.pinboardPage.description": "Drag a card onto a group on the left, or add it to one or more groups via “Add”. Dragging onto “All” removes it from the current group.",
  "save.pinboardPage.emptyAllGrouped": "All pinned {typeLabel} are in groups.",
  "save.pinboardPage.emptyNoneInView": "No pinned {typeLabel} in this view.",
  "save.pinboardPage.itemFallback": "Entry",
  "save.pinboardPage.openItem": "Open {name}",
  "save.pinboardPage.removeFromGroup": "Remove from group",
  "save.pinboardPage.removeFromGroupMessage": "Remove “{title}” from “{group}” (stays pinned and in other groups) or unpin completely?",
  "save.pinboardPage.removePin": "Remove pin",
  "save.pinboardPage.title": "Pins",
  "save.pinboardPage.typePersons": "People",
  "save.pinboardPage.typePosts": "Posts",
  "save.pinboardPage.typeProjects": "Projects",
  "save.pinboardPage.ungroupedLabel": "Pins without a group",
  "save.pinboardPage.unpin": "Unpin",
  "save.pinboardPage.unpinCompletely": "Unpin completely",
  "save.pinboardPage.unpinMessage": "Unpin “{title}”?",
  "search.activeCount": "{count} active",
  "search.allFiltersAdded": "All filters added",
  "search.any": "Any",
  "search.chipType": "Type",
  "search.clear": "Clear search",
  "search.confirmRemoveFromGroup": "Remove?",
  "search.discoverHeading": "Discover",
  "search.done": "Done",
  "search.either": "Either",
  "search.errorPrefix": "Error: {message}",
  "search.extended": "Extended search",
  "search.eyebrow": "Search",
  "search.fieldAge": "Age",
  "search.fieldChildren": "Number of children",
  "search.fieldCitizenship": "Citizenship",
  "search.fieldCity": "Place of residence",
  "search.fieldCountry": "Country",
  "search.fieldDepartment": "Department",
  "search.fieldExpertise": "Expertise",
  "search.fieldFirstName": "First name",
  "search.fieldGender": "Gender",
  "search.fieldIndustry": "Industry",
  "search.fieldJobTitle": "Job title",
  "search.fieldLanguages": "Languages",
  "search.fieldLastName": "Last name",
  "search.fieldLocation": "Work location",
  "search.fieldMaritalStatus": "Marital status",
  "search.fieldNationality": "Nationality",
  "search.fieldCompanySize": "Size (employees)",
  "companyFilter.heading": "Company filters{count, plural, =0 {} other { · # active}}",
  "search.filterHeading": "{type} filters",
  "search.flagCommented": "Commented",
  "search.flagOwner": "Owner",
  "search.flagPinned": "Pinned",
  "search.flagRated": "Rated",
  "search.flagSignedUp": "Interested",
  "search.groupPosts": "Posts",
  "search.groupCompanies": "Companies",
  "search.groupProjects": "Projects",
  "search.groupTeamplayers": "Team players",
  "search.hide": "Hide ▴",
  "search.no": "No",
  "search.noFilters": "No filters set.",
  "search.noResults": "No matches",
  "search.openChat": "Open chat",
  "search.pin": "Pin",
  "search.pinInto": "Pin into {name}",
  "search.pinNoGroup": "Pin (no group)",
  "search.placeholder": "Search team players, projects, posts …",
  "search.placeholderPerson": "Name, job title …",
  "search.placeholderShared": "Title, description …",
  "search.placeholderCompany": "Company name, expertise, industry …",
  "search.publisher": "Published by",
  "search.publisherCompany": "Companies",
  "search.publisherPerson": "People",
  "search.queryLabel": "Search term",
  "search.rangeTo": "to",
  "search.removeFieldLabel": "Remove {field}",
  "search.removeFromGroup": "Remove from {name}",
  "search.reset": "Reset",
  "search.resultCount": "{count} {type}",
  "search.resultCountMore": "{count}+ {type}",
  "search.resultCountOf": "{count} of {total} {type}",
  "search.search": "Search",
  "search.searching": "Searching …",
  "search.show": "Show ▾",
  "search.tabShare": "Share",
  "search.tabTeamplayer": "Teamplayer",
  "search.tabCompany": "Companies",
  "search.tour.filters.desc": "Build structured filters here and combine them with the free-text search term above, then hit Search. {count} filters are active right now.",
  "search.tour.filters.emptyDesc": "Build structured filters here and combine them with the free-text search term above, then hit Search. No filters are set right now.",
  "search.tour.filters.title": "Filters",
  "search.tour.label": "Search",
  "search.tour.results.desc": "The matches appear here, currently {summary}. Click a result to open it; scrolling down loads more.",
  "search.tour.results.title": "Results",
  "search.tour.summary": "This is the extended search. Find people, companies, or shared projects and posts. You are currently searching {type}.",
  "search.tour.typeToggle.desc": "Switch the search category: Teamplayer finds people, Companies finds companies by name, expertise or industry, and Share finds projects and posts.",
  "search.tour.typeToggle.title": "What to search",
  "search.typeAll": "All",
  "search.typePosts": "Posts",
  "search.typeProjects": "Projects",
  "search.unpin": "Unpin",
  "search.useExtended": "Use extended search",
  "search.writeMessage": "Write a message",
  "search.yes": "Yes",
  "search.removeTermLabel": "Remove {term}",
  "search.addTermPlaceholder": "Type a term, then press Enter",
  "secretInput.hide": "Hide value",
  "secretInput.show": "Show value",
  "service.docItemRow.download": "Download",
  "service.docItemRow.newBadge": "New",
  "service.docItemRow.open": "Open",
  "service.docItemRow.rename": "Click to rename",
  "service.docItemRow.selectAriaLabel": "Select {name}",
  "service.docItemRow.sourceLabel": "Source: {source}",
  "service.docPreviewCard.cvGeneratorDraft": "CV-Generator draft",
  "service.docPreviewCard.download": "Download",
  "service.docPreviewCard.newBadge": "New",
  "service.docPreviewCard.open": "Open",
  "service.docPreviewCard.rename": "Click to rename",
  "service.docPreviewCard.selectAriaLabel": "Select {name}",
  "service.error.nameRequired": "A name is required.",
  "service.extRename.ariaLabel": "Rename",
  "service.filterBuilder.addFilter": "+ Add filter",
  "service.filterBuilder.all": "All",
  "service.filterBuilder.allFiltersAdded": "All filters added",
  "service.filterBuilder.clear": "Clear",
  "service.filterBuilder.done": "Done",
  "service.filterBuilder.removeFilterLabel": "Remove {label}",
  "service.folderRow.deleteFolder": "Delete folder",
  "service.folderRow.deleteFolderAria": "Delete folder {name}",
  "service.folderRow.deleteFolderOnlyHint": "Delete only the folder: {count} file(s) move to “Unsorted”",
  "service.folderRow.deleteLabel": "Delete:",
  "service.folderRow.deleteWithFilesHint": "Permanently delete the folder along with {count} file(s)",
  "service.folderRow.folderNamePlaceholder": "Folder name …",
  "service.folderRow.folderOnly": "Folder only",
  "service.folderRow.newFolder": "New folder",
  "service.folderRow.renameFolder": "Rename folder",
  "service.folderRow.toggleHint": "Expand/collapse (double-click: rename)",
  "service.folderRow.withFiles": "With files",
  "service.page.allInFolders": "Everything filed in folders",
  "service.page.bulkCv.addMore": "Add files",
  "service.page.bulkCv.addToCommunity": "Community",
  "service.page.bulkCv.addedToCommunity": "Added {n} to {names}",
  "service.page.bulkCv.communitySubject": "{n} imported people",
  "service.page.bulkCv.desc": "Drop multiple CVs to create or update the corresponding profiles. Existing profiles are only filled where empty – nothing is overwritten.",
  "service.page.bulkCv.dupWarning": "CVs without an email create a new profile on every run. Avoid re-importing the same files.",
  "service.page.bulkCv.hint": "PDF, DOCX, images … · max. 10 MB per file · up to 25 files",
  "service.page.bulkCv.importBtn": "Import {n, plural, one {# CV} other {# CVs}}",
  "service.page.bulkCv.importPhoto": "Import photo",
  "service.page.bulkCv.importing": "Importing {done}/{total} …",
  "service.page.bulkCv.openProfile": "profile",
  "service.page.bulkCv.outcomeCreated": "New",
  "service.page.bulkCv.outcomeFailed": "couldn't import",
  "service.page.bulkCv.outcomeUpdated": "Updated",
  "service.page.bulkCv.rejected": "Some files were skipped (too large or unsupported type).",
  "service.page.bulkCv.summary": "{created} created, {updated} updated, {failed} failed",
  "service.page.bulkCv.title": "Import profiles",
  "service.page.bulkCv.tooMany": "You can import at most {max} files at once.",
  "service.page.bulkCv.willAddToCommunity": "New imports will be added to: {names}",
  "service.page.bulkCv.zone": "Drag CVs here or click to add",
  "service.page.cardCvExtractorDesc": "Parses PDF/DOCX résumés and imports positions, skills and data in a structured way.",
  "service.page.cardCvExtractorTitle": "CV extractor",
  "service.page.cardCvGeneratorDesc": "Generates a résumé from profile data - appears on the right in DOCUMENTS.",
  "service.page.cardCvGeneratorTitle": "CV generator",
  "service.page.cardDatatransferDesc": "Exports your profile and grow data as a JSON file (GDPR Art. 20) - appears in DOCUMENTS and downloads immediately.",
  "service.page.cardDatatransferTitle": "Data transfer",
  "service.page.cardHardskillDesc": "Detects technical hard skills and tools from your profile and rates their level.",
  "service.page.cardHardskillTitle": "Hard skill analysis",
  "service.page.cardLinkedinDesc": "Imports profile, positions and skills directly from your LinkedIn account.",
  "service.page.cardLinkedinTitle": "LinkedIn import",
  "service.page.cardPowerDesc": "Identifies powers, skills and experience from free text and self-description.",
  "service.page.cardPowerTitle": "Power analysis",
  "service.page.clearSelection": "Clear selection",
  "service.page.confirmDelete": "Really delete?",
  "service.page.cvFallbackName": "CV",
  "service.page.cvNotMovable": "CV drafts cannot be moved into folders",
  "service.page.docOpening": "Document loading …",
  "service.page.documentDeleteBlocked": "This document is still used in shared posts. Remove it there first:",
  "service.page.documentsCount": "{total} documents",
  "service.page.documentsHint": "All files you have uploaded or generated through the profile services.",
  "service.page.documentsTitle": "Documents",
  "service.page.dropIntoFolder": "Drop to upload into this folder",
  "service.page.errDownload": "Download failed.",
  "service.page.errExport": "Data export failed.",
  "service.page.errExportSave": "Export could not be saved.",
  "service.page.errFolderCreate": "Folder could not be created.",
  "service.page.errFolderLimit": "You have reached the maximum of {limit} folders.",
  "service.page.errFolderDelete": "Folder could not be deleted.",
  "service.page.errFolderRename": "Folder could not be renamed.",
  "service.page.errMove": "Move failed.",
  "service.page.errNoContent": "No content available.",
  "service.page.errNotSignedInExport": "Not signed in - export not possible.",
  "service.page.errNotSignedInUpload": "Not signed in - upload not possible.",
  "service.page.errOpen": "Opening failed.",
  "service.page.errPopupBlocked": "The browser blocked opening in a new tab - please allow pop-ups for this site and click Open again.",
  "service.page.errProfileLoad": "Profile data could not be loaded.",
  "service.page.errRename": "Rename failed.",
  "service.page.errUploadDuplicate": "Upload failed. A document with this name probably already exists.",
  "service.page.errUploadNameTaken": "Already in Documents, not uploaded again: {names}.",
  "service.page.error": "Error: {message}",
  "service.page.exporting": "Exporting …",
  "service.page.filterFileType": "Filetype",
  "service.page.filterPlaceholder": "Filter your available documents …",
  "service.page.filterSource": "Source",
  "service.page.folderEmpty": "Folder is empty - drag documents onto the folder tile.",
  "service.page.hardskillAnalysisTitle": "Hard skill analysis",
  "service.page.inputTitle": "Build profile",
  "service.page.maxPerFile": "max. 10 MB per file",
  "service.page.moveToFolder": "Move to folder",
  "service.page.noDocuments": "No documents",
  "service.page.noFolders": "No folders available",
  "service.page.noMatches": "No matches",
  "service.page.noMatchesInFolder": "No matches in this folder",
  "service.page.onlyRealFilesMovable": "Only real files can be moved into folders, not CV generator entries.",
  "service.page.openBlockingSharedItem": "Open shared post {number}",
  "service.page.orDragAndDrop": "Or via drag & drop",
  "service.page.outputTitle": "Export profile",
  "service.page.powerAnalysisTitle": "Power analysis",
  "service.page.removeBlockingSelection": "Remove blocking selection",
  "service.page.reset": "Reset",
  "service.page.selectedCount": "{count} selected",
  "service.page.sourceCvGenerator": "CV generator",
  "service.page.sourceUpload": "File upload",
  "service.page.unsorted": "Unsorted",
  "service.page.uploadFile": "Upload file",
  "service.page.uploading": "Uploading …",
  "service.page.viewCompact": "Compact",
  "service.page.viewPreview": "Preview",
  "service.tour.filters.desc": "Filter your documents by name, source or file type, and switch between preview and compact view.",
  "service.tour.filters.title": "Search & filter",
  "service.tour.label": "Save Documents",
  "service.tour.list.desc": "{count} documents in {folders} folders. Open a folder to see its files, drag documents between folders, and hover a row to rename, select or delete it.",
  "service.tour.list.title": "Your documents",
  "service.tour.summary": "This is your documents page: {count} documents in {folders} folders, from manual uploads to generated CVs.",
  "service.tour.upload.desc": "Upload files here (max. 10 MB each), or simply drag and drop them onto a folder or the list below.",
  "service.tour.upload.title": "Upload files",
  "settings.account.delete.button": "Delete account",
  "settings.account.delete.confirm": "Delete permanently",
  "settings.account.delete.desc": "Your account and all associated data are permanently deleted. This cannot be undone.",
  "settings.account.delete.dialogTitle": "Permanently delete account?",
  "settings.account.delete.error": "Deletion failed. Please try again.",
  "settings.account.delete.placeholder": "Full name",
  "settings.account.delete.prompt": "Type your full name to confirm:",
  "settings.account.delete.title": "Delete account",
  "settings.account.delete.zone": "Danger zone",
  "settings.eyebrow": "Platform configuration",
  "settings.heading": "Admin",
  "settings.intro": "Branding, managed reference data, questionnaires and appearance.",
  "settings.sectionAI": "AI",
  "settings.sectionAccessConfig": "Feature whitelist",
  "settings.sectionBranding": "Branding",
  "settings.sectionEmailTemplates": "Email templates",
  "settings.sectionFragebogen": "Questionnaires",
  "settings.sectionHrPrompt": "HR prompt",
  "settings.sectionRoster": "Import",
  "settings.sectionStammdaten": "Master data",
  "settings.sectionStyleguide": "Styleguide",
  "settings.styleguide.buttons.specimen.combined": "Combined",
  "settings.upload.appearance.area": "Settings",
  "settings.upload.appearance.limit": "up to 16 MB",
  "settings.upload.appearance.note": "base64-inline, BFF limit",
  "settings.upload.appearance.what": "Logo & background image",
  "settings.upload.docs.area": "Save · Documents",
  "settings.upload.docs.limit": "10 MB per file",
  "settings.upload.docs.what": "File upload (PDF, DOCX, …)",
  "settings.upload.generalNote": "All uploads are base64-encoded and routed through the BFF, which allows max. 16 MB per request. Since base64 inflates the size by about 33 %, the actual file limits sit somewhat below that.",
  "settings.upload.profile.area": "Profile",
  "settings.upload.profile.limit": "5 MB",
  "settings.upload.profile.what": "Profile photo / avatar",
  "settings.upload.shareAttach.area": "Share · Attachments",
  "settings.upload.shareAttach.limit": "up to 16 MB",
  "settings.upload.shareAttach.note": "technical ceiling (BFF)",
  "settings.upload.shareAttach.what": "File attachments on items",
  "settings.upload.shareImage.area": "Share · Items",
  "settings.upload.shareImage.limit": "5 MB per image",
  "settings.upload.shareImage.what": "Cover image",
  "share.comment.saveFailed": "The comment could not be saved.",
  "share.create.actingAsCompany": "Posting as {company}. Leave the company context to post as yourself.",
  "share.create.attachmentsLabel": "Attachments",
  "share.create.authorLabel": "Author",
  "share.create.commentsAfterPublish": "Available after publishing.",
  "share.create.commentsLabel": "Comments",
  "share.create.createHeading": "{type, select, POST {New post} other {New project}}",
  "share.create.descriptionLabel": "Description",
  "share.create.descriptionPlaceholder": "{type, select, POST {Describe your post …} other {Describe your project …}}",
  "share.create.editHeading": "{type, select, POST {Edit post} other {Edit project}}",
  "share.create.existingAttachment": "Attachment {n}",
  "share.create.existingImage": "Image {n}",
  "share.create.eyebrowCreate": "Create",
  "share.create.eyebrowEdit": "Edit",
  "share.create.eyebrowPreview": "Preview",
  "share.create.fromDocuments": "From my documents",
  "share.create.imagesLabel": "Images",
  "share.create.loadingFiles": "loading…",
  "share.create.mainImageBadge": "Preview",
  "share.create.mainImageHint": "Set as preview image",
  "share.create.noDescription": "No description.",
  "share.create.previewButton": "Preview",
  "share.create.previewHeading": "Here's how it looks",
  "share.create.publish": "Publish",
  "share.create.publishedAtLabel": "Published on",
  "share.create.ratingLabel": "Rating",
  "share.create.shortDescriptionLabel": "Short description",
  "share.create.shortDescriptionPlaceholder": "In one sentence: what is it about?",
  "share.create.statComments": "Comments",
  "share.create.statInterested": "Interested",
  "share.create.statPins": "Pins",
  "share.create.statRatings": "Ratings",
  "share.create.statViews": "Views",
  "share.create.titleLabel": "Title",
  "share.create.titlePlaceholder": "{type, select, POST {Title of the post} other {Title of the project}}",
  "share.create.tooLarge": "Too large (max. {max} MB per file): {names}",
  "share.create.typeLabel": "Type",
  "share.create.typePost": "Post",
  "share.create.typeProject": "Project",
  "share.create.unsupportedType": "Unsupported file type: {names}",
  "share.create.untitled": "Untitled",
  "share.docPicker.confirm": "Add {count}",
  "share.docPicker.empty": "No documents in your vault yet.",
  "share.docPicker.emptyImages": "No images in your documents yet.",
  "share.docPicker.hint": "Selected documents are attached to the post as a copy.",
  "share.docPicker.loadFailed": "Loading documents failed.",
  "share.docPicker.noMatches": "No matches",
  "share.docPicker.search": "Search documents",
  "share.docPicker.title": "Add from my documents",
  "share.docPicker.unnamedDocument": "Unnamed document",
  "share.itemDetail.alreadyRated": "You have already rated, tap again to change.",
  "share.itemDetail.attachmentDownloadFailed": "Download failed.",
  "share.itemDetail.attachmentOpenFailed": "Open failed.",
  "share.itemDetail.attachmentUnnamed": "Attachment",
  "share.itemDetail.attachments": "Attachments",
  "share.itemDetail.commentAsCompanyBlocked": "You are acting as {company}. Leave the company context to comment as yourself.",
  "share.itemDetail.downloadAttachment": "Download {name}",
  "share.itemDetail.openAttachment": "Open {name}",
  "share.itemDetail.author": "Author",
  "share.itemDetail.commentPlaceholder": "Write a comment…",
  "share.itemDetail.comments": "Comments",
  "share.itemDetail.deleteConfirm": "Delete?",
  "share.itemDetail.error": "Error: {message}",
  "share.itemDetail.expressInterest": "Express interest",
  "share.itemDetail.imageN": "Image {n}",
  "share.itemDetail.linkedMatchTitle": "Start a new match linked to this share item",
  "share.itemDetail.loading": "loading…",
  "share.itemDetail.more": "More",
  "share.itemDetail.newMatch": "New match ↗",
  "share.itemDetail.no": "No",
  "share.itemDetail.noComments": "No comments yet, be the first.",
  "share.itemDetail.noDescription": "No description",
  "share.itemDetail.noDescriptionHint": "no content provided",
  "share.itemDetail.notFound": "Post not found",
  "share.itemDetail.postedByOperator": "Posted by {name}",
  "share.itemDetail.publishedBy": "Published by",
  "share.itemDetail.publishedOn": "Published on",
  "share.itemDetail.rateYourselfTitle": "Click to rate it yourself",
  "share.itemDetail.rating": "Rating",
  "share.itemDetail.ratingClose": "close",
  "share.itemDetail.ratingOpen": "rate ›",
  "share.itemDetail.ratingsCount": "({count} ratings)",
  "share.itemDetail.send": "Send",
  "share.itemDetail.share": "Share",
  "share.itemDetail.shareWithIcon": "↗ Share",
  "share.itemDetail.signedUpWithdraw": "✓ Interested - withdraw",
  "share.itemDetail.starsAriaLabel": "{n} of 5 stars",
  "share.itemDetail.starsTitle": "{n, plural, one {# star} other {# stars}}",
  "share.itemDetail.statInterested": "Interested",
  "share.itemDetail.statPins": "Pins",
  "share.itemDetail.statViews": "Views",
  "share.itemDetail.thanks": "Thanks!",
  "share.itemDetail.tour.actions.desc": "Watch the item to follow it, or start a new match linked to it.",
  "share.itemDetail.tour.actions.projectDesc": "Watch the item to follow it, express interest to sign up as a participant, or start a new match linked to this project.",
  "share.itemDetail.tour.actions.title": "Get involved",
  "share.itemDetail.tour.content.desc": "Title, image gallery and full description of \"{name}\". Click the thumbnails to browse the images.",
  "share.itemDetail.tour.content.title": "The content",
  "share.itemDetail.tour.label": "Share Post",
  "share.itemDetail.tour.stats.desc": "The item's reach so far: {views} views, {pins} pins and {signUps} interested people.",
  "share.itemDetail.tour.stats.title": "How it's doing",
  "share.itemDetail.tour.summary": "You are looking at \"{name}\", a {type} from the Share community.",
  "share.itemDetail.unwatch": "✓ Watching - remove",
  "share.itemDetail.watch": "Watch",
  "share.itemDetail.yes": "Yes",
  "share.landing.carouselDiscussed": "Most comments",
  "share.landing.carouselInterest": "Most interested",
  "share.landing.carouselNew": "Newest",
  "share.landing.carouselTop": "Top rated",
  "share.landing.discoverAllPosts": "Discover all posts ↗",
  "share.landing.discoverEyebrow": "Discover",
  "share.landing.error": "Error: {message}",
  "share.landing.heroBody": "Publish projects and posts, gather interested people, feedback and reach. And discover what the community is currently building.",
  "share.landing.heroCta": "Create ↗",
  "share.landing.heroSubtitleLine1": "Show what you are working on.",
  "share.landing.heroSubtitleLine2": "Find who joins in.",
  "share.landing.loading": "loading…",
  "share.landing.myActivity": "My activity",
  "share.landing.myProjectsSection": "My projects & posts",
  "share.landing.next": "Next",
  "share.landing.noOwnPosts": "No own posts yet",
  "share.landing.noOwnPostsHint": "create a project or a post",
  "share.landing.noSharedItems": "No shared items available.",
  "share.landing.noShortDescription": "No short description.",
  "share.landing.nothingWatched": "Nothing watched or involved yet",
  "share.landing.nothingWatchedHint": "Watch projects & posts or get involved.",
  "share.landing.open": "Open ↗",
  "share.landing.previous": "Previous",
  "share.landing.share": "↗ Share",
  "share.landing.slide": "Slide {number}",
  "share.landing.statComments": "Comments",
  "share.landing.statInterested": "Interested",
  "share.landing.statRatings": "Ratings",
  "share.landing.statViews": "Views",
  "share.landing.tour.activity.desc": "The {count} items you are watching or signed up for, so you can get back to them quickly.",
  "share.landing.tour.activity.emptyDesc": "Items you watch or sign up for will collect here; nothing yet. Open an item and hit Watch or Express interest.",
  "share.landing.tour.activity.title": "Watched & involved",
  "share.landing.tour.carousel.desc": "Four curated top-5 lists: top rated, newest, most interested, most comments. Switch lists with the tabs; currently showing \"{featured}\". Click Open to jump into an item.",
  "share.landing.tour.carousel.title": "Discover",
  "share.landing.tour.create.desc": "Publish your own project or post here. Describe it, add images, and collect interested people.",
  "share.landing.tour.create.title": "Create something",
  "share.landing.tour.emptySummary": "This is Share, the community feed where people publish projects and posts, gather interested people and feedback.",
  "share.landing.tour.label": "Share",
  "share.landing.tour.mine.desc": "Your own {count} published items. 'View all' opens the full list where you can manage them.",
  "share.landing.tour.mine.emptyDesc": "Your own published items will appear here. You haven't created any yet.",
  "share.landing.tour.mine.title": "My projects & posts",
  "share.landing.tour.summary": "This is Share, the community feed where people publish projects and posts, gather interested people and feedback. Right now \"{name}\" is in the spotlight.",
  "share.landing.viewAll": "View all ↗",
  "share.landing.watchedSection": "Watched & involved",
  "share.mine.emptyHint": "create a project or a post",
  "share.mine.emptyLabel": "No own posts yet",
  "share.mine.error": "Error: {message}",
  "share.mine.eyebrow": "SHARE · My posts",
  "share.mine.filterAll": "All",
  "share.mine.filterPosts": "Posts",
  "share.mine.filterProjects": "Projects",
  "share.mine.subtitle": "All your projects and posts.",
  "share.mine.title": "My posts",
  "share.mine.tour.filters.desc": "Narrow the list to Projects or Posts, and change the sort order on the right.",
  "share.mine.tour.filters.title": "Filter & sort",
  "share.mine.tour.items.desc": "{count} items. Click one to open it; as the owner you can edit or delete it from its detail page.",
  "share.mine.tour.items.emptyDesc": "Nothing here yet. Create a project or a post and it will show up in this grid.",
  "share.mine.tour.items.title": "Your items",
  "share.mine.tour.label": "Share Mine",
  "share.mine.tour.summary": "These are your own posts, everything you have published on Share. You have {count} items here right now.",
  "skill.catAwareness": "Awareness & Learning",
  "skill.catImpact": "Create Impact & Influence",
  "skill.catPractical": "Practical Application & Skill Proficiency",
  "skill.desc.1": "You know basic concepts of this competency and have had first touchpoints with it, but do not yet use it practically.",
  "skill.desc.2": "You are actively building foundations in this competency and can handle first simple tasks with support and clear guidance.",
  "skill.desc.3": "You already use this competency in first practical situations and can complete simple tasks independently.",
  "skill.desc.4": "You use this competency regularly and can solve typical tasks reliably and independently.",
  "skill.desc.5": "You have deep practical experience and use this competency confidently in varied, complex, and demanding situations.",
  "skill.desc.6": "You are a recognized reference for this competency and strengthen others in applying it by effectively establishing best practices in the team or organization.",
  "skill.desc.7": "You develop forward-looking approaches for this competency and provide direction-setting impulses that lead to new standards.",
  "skill.infoLabel": "Level description",
  "skill.levelName.1": "Explorer",
  "skill.levelName.2": "Builder",
  "skill.levelName.3": "Contributor",
  "skill.levelName.4": "Practitioner",
  "skill.levelName.5": "Specialist",
  "skill.levelName.6": "Multiplier",
  "skill.levelName.7": "Pioneer",
  "skill.levelTitle.1": "Getting to know it & first touchpoints",
  "skill.levelTitle.2": "Focused development",
  "skill.levelTitle.3": "First practical applications",
  "skill.levelTitle.4": "Regular & reliable practical application",
  "skill.levelTitle.5": "Confident use in demanding contexts",
  "skill.levelTitle.6": "Empowering & developing others",
  "skill.levelTitle.7": "Shaping what is next & driving innovation",
  "sort.az": "A–Z",
  "sort.label": "Sort",
  "sort.nameAz": "Name A–Z",
  "sort.nameZa": "Name Z–A",
  "sort.new": "Newest",
  "sort.old": "Oldest",
  "sort.top": "Top rated",
  "stammdaten.details": "Details",
  "stammdaten.experience": "Work experience",
  "stammdaten.organisation": "Organisation",
  "stammdaten.teamprofil": "Power Scorecards",
  "suggestions.activities": "Suggest tasks",
  "suggestions.add": "Tap to add",
  "suggestions.addTask": "+ Add task",
  "suggestions.empty": "No suggestions found",
  "suggestions.loading": "Loading suggestions…",
  "suggestions.needJobTitle": "Enter a job title first",
  "suggestions.retry": "Try again",
  "suggestions.unavailable": "Suggestions currently unavailable",
  "teamProfile.confirmDelete.message": "The profile is removed for good and it will no longer be offered when designing a Match.",
  "teamProfile.confirmDelete.title": "Delete “{label}”?",
  "teamProfile.create.sub": "Starts with every power weighted equally. Open the profile afterwards to tune the weights.",
  "teamProfile.create.submit": "Create profile",
  "teamProfile.create.title": "New profile",
  "teamProfile.delete": "Delete profile",
  "teamProfile.duplicate": "A profile with this name already exists.",
  "teamProfile.truncated": "Showing the first {shown} of {total} profiles. Delete or rename profiles you no longer need.",
  "teamProfile.empty": "No profiles yet.",
  "teamProfile.loading": "Loading…",
  "teamProfile.nameDe": "Name (German)",
  "teamProfile.nameEn": "Name (English)",
  "teamProfile.presetBadge": "Template",
  "teamProfile.presetHint": "Name and weights of this template are set by Smycles and cannot be changed. Create your own profile if you need different weights.",
  "teamProfile.reset": "Discard changes",
  "teamProfile.save": "Save",
  "teamProfile.saveFailed": "The profile could not be saved.",
  "teamProfile.sub": "Named weightings across the 30 powers, offered when designing a Match. Explore, Exploit and Ausgewogen are templates from Smycles: their name and weights are fixed.",
  "teamProfile.title": "Power Scorecards",
  "teamProfile.weights": "Importance",
  "topbar.help.choiceNews": "Show what's new",
  "topbar.help.choiceTour": "Start the tour",
  "topbar.help.hint": "New here? Start the guided tour of the app with this button.",
  "topbar.help.hintDismiss": "Dismiss",
  "topbar.help.hintNews": "Something has changed since your tour. This button shows you what's new.",
  "topbar.help.label": "Start the guided tour",
  "unsavedGuard.body": "You have changes that haven't been saved yet. If you leave this page, they will be lost.",
  "unsavedGuard.discard": "Discard",
  "unsavedGuard.save": "Save",
  "unsavedGuard.stay": "Stay here",
  "unsavedGuard.title": "Unsaved changes",
  "userSettings.claude.adminInstallLink": "Open the pre-filled dialog for organization owners",
  "userSettings.claude.appDesc": "Add Smycles once as a connector in your Claude account, then it works across the Claude desktop app, the web app and mobile.",
  "userSettings.claude.appInternalHint": "Note: Claude connects from its own cloud, so this does not work on internal systems for now. The Smycles server has to be reachable from the public internet. Claude Code (below) works on internal systems today.",
  "userSettings.claude.appStep1": "In Claude, open Settings, then Connectors.",
  "userSettings.claude.appStep2": "Choose Add custom connector and paste the Server URL above.",
  "userSettings.claude.appStep3": "Open Advanced settings, enter the Client ID above, and leave the client secret empty.",
  "userSettings.claude.appStep4": "Add the connector, then Connect and sign in with your Smycles account.",
  "userSettings.claude.appTeamNote": "On Team and Enterprise plans an organization owner adds the connector once; everyone else only clicks Connect and signs in.",
  "userSettings.claude.appTitle": "Claude app (desktop, web and mobile)",
  "userSettings.claude.clientIdLabel": "Client ID",
  "userSettings.claude.codeDesc": "Run this command, then start Claude Code, run /mcp, choose smycles and select Authenticate. A browser window opens for the Smycles login.",
  "userSettings.claude.codeTitle": "Claude Code (for developers)",
  "userSettings.claude.commandLabel": "Command",
  "userSettings.claude.detailsTitle": "Connection details",
  "userSettings.claude.eyebrow": "Claude",
  "userSettings.claude.installAudience": "The button is for personal Claude accounts (Free, Pro and Max) and for organization owners on Team and Enterprise plans. On a Team or Enterprise plan without owner rights you don't need it: your organization owner adds the connector once, and Smycles then appears in your Claude under Settings \u2192 Connectors \u2013 just click Connect there.",
  "userSettings.claude.installButton": "Add to Claude",
  "userSettings.claude.installHint": "The button opens Claude with the name and Server URL already filled in \u2013 just confirm. Then continue with step 3 below: enter the Client ID under Advanced settings.",
  "userSettings.claude.intro": "Use your Smycles data and tools directly inside Claude. Claude sees exactly what you can see; you sign in with your normal Smycles account. This is separate from the assistant built into Smycles.",
  "userSettings.claude.noSecret": "No client secret is needed. Leave the secret field empty.",
  "userSettings.claude.title": "Connect Claude",
  "userSettings.claude.urlLabel": "Server URL",
  "userSettings.mcpApp.appsTitle": "Apps",
  "userSettings.mcpApp.callbackHostLabel": "Callback host",
  "userSettings.mcpApp.callbackPortLabel": "Callback port",
  "userSettings.mcpApp.desktopStep1": "Connect to the company VPN. In Claude Desktop, enable Help → Troubleshooting → Enable Developer Mode, then open Developer → Configure Third-Party Inference.",
  "userSettings.mcpApp.desktopStep2": "In the Connection section, choose Anthropic API as the inference provider and enter your Anthropic API key. Skip this if Claude Desktop already runs in third-party mode.",
  "userSettings.mcpApp.desktopStep3": "Under Connectors, add a server: transport Streamable HTTP, URL from the list above.",
  "userSettings.mcpApp.desktopStep4": "Under OAuth choose Bring your own client and enter the Client ID from above plus the callback host and port below. Leave the client secret empty.",
  "userSettings.mcpApp.desktopStep5": "Apply the changes and restart Claude Desktop. Then open Settings → Connectors, Connect, and sign in with your Smycles account in the browser window.",
  "userSettings.mcpApp.externalDesc": "When this environment is reachable from the internet, every app is added in Claude as its own custom connector, separate from the main Smycles connector, using its URL from the list above.",
  "userSettings.mcpApp.externalTitle": "External environments – Claude app (desktop, web and mobile)",
  "userSettings.mcpApp.internalDesc": "On intranet environments (e.g. trunk), claude.ai and the standard Claude apps cannot connect: they dial from Anthropic's cloud, not from your device. Use Claude Desktop in third-party inference mode on the VPN instead. Every app is its own connector; use its URL from the list above.",
  "userSettings.mcpApp.internalTitle": "Internal environments – Claude Desktop on the VPN",
  "userSettings.mcpApp.intro": "Interactive Smycles apps rendered directly inside your Claude conversations. You sign in with your normal Smycles account, and each app sees exactly what you can see.",
  "userSettings.mcpApp.oauthDesc": "Connectors authenticate with OAuth: when you connect, Claude opens the Smycles sign-in, and the app then acts with exactly your permissions. All apps share the public client below.",
  "userSettings.mcpApp.oauthTitle": "Sign-in (OAuth)",
  "userSettings.mcpApp.title": "Apps in Claude",
  "userSettings.data.desc": "Export your profile and Grow data as a JSON file (GDPR Art. 20). Find data transfer in your profile under \"Service\".",
  "userSettings.data.link": "Go to data transfer ↗",
  "userSettings.data.title": "Data export",
  "userSettings.email": "Email",
  "userSettings.eyebrow": "Account · Preferences",
  "userSettings.heading": "Settings",
  "userSettings.identityTitle": "Identity",
  "userSettings.intro": "Manage your account, notifications and privacy.",
  "userSettings.language": "Language",
  "userSettings.languageHint": "Also used for AI generation.",
  "userSettings.name": "Name",
  "userSettings.sectionAccount": "Account",
  "userSettings.sectionConnections": "Connections",
  "userSettings.sectionData": "Data & export",
  "userSettings.tour.content.accountDesc": "Your identity (name and email), the interface language (also used for AI generation) and, at the bottom, account deletion.",
  "userSettings.tour.content.dataDesc": "Export your profile and Grow data as a JSON file (GDPR Art. 20). The button hands you over to the data transfer.",
  "userSettings.tour.content.title": "The active section",
  "userSettings.tour.label": "Settings",
  "userSettings.tour.nav.desc": "Switch between Account (identity, language, deletion) and Data & export (your GDPR data export).",
  "userSettings.tour.nav.title": "The sections",
  "userSettings.tour.summary": "These are your account settings: identity, interface language, data export and account deletion.",
  "whatsNew.v0_1": "New in Smycles: connect the Claude apps to your data. This settings page shows you how, with the MCP endpoint, the client id and a step-by-step guide.",
  "match.result.facts.leniencyDependent": "{count, plural, one {# requirement only counts as fulfilled under lenient checking} other {# requirements only count as fulfilled under lenient checking}}: the expertise is there, the required level is not evidenced.",
  "match.result.facts.lenientMark": "Lenient",
  "match.result.memberLenientTag": "lenient",
  "match.result.riskEmptyCluster": "{count, plural, one {# cluster with no carrier} other {# clusters with no carrier}}",
  "match.result.riskSoleRequirement": "{count, plural, one {# requirement rests on one person} other {# requirements rest on one person}}",
  "match.result.riskViolatedMust": "{count, plural, one {# must violated} other {# musts violated}}",
  "match.result.wishFitInfoAria": "Show explanation of the weighting",
  "match.result.wishFitInfoBody": "The Powers Scorecard is where you set which powers matter to you (0–10). The number says whether the team sits above or below its own average across all 30 powers exactly there; powers weighted 0 don't count. A weighting is not a requirement: it steers the selection but sets no threshold – so there is nothing to meet or miss here. Who brings each power strongly is in “Top Powers”.",
  "match.result.wishFitInfoTitle": "What is being compared here",
  "match.result.wishFitPoolNote": "the candidate pool had nothing closer",
  "match.result.wishFitDelta": "{delta} versus the average across all 30 powers",
  "match.result.powersScorecardInTeam": "Team vs Powers Scorecard",
  "match.result.powersBasis": "Based on {measured} of {total} people",
  "match.result.powersCoverageInfo": "No power assessment is on file for {missing, plural, one {# person} other {# people}} on the team. All power averages and counts run over the remaining {measured} only; who is missing is listed at the end of the Power Scorecard matrix.",
  "match.result.powersCoverageInfoAria": "Show explanation of powers coverage",
  "match.result.powersInTeam": "Powers in the team",
  "common.forbidden": "You do not have the required permissions for this action.",
  "common.forbiddenWithCode": "You do not have the required permissions for this action. (Code {code})",
  "service.page.imports.accountProvisioningHint": "Note: These imports create or update profiles. No login details are created, so imported people cannot sign in directly afterwards.",
  "service.page.bulkYaml.actionDry": "Validate",
  "service.page.bulkYaml.actionLabel": "Mode",
  "service.page.bulkYaml.actionReal": "Import",
  "service.page.bulkYaml.background": "Runs in background",
  "service.page.bulkYaml.batchDone": "All {n, number} files are uploaded. Processing continues in the background - you may leave this page.",
  "service.page.bulkYaml.batchFailed": "Failed",
  "service.page.bulkYaml.batchLimit": "At most {max, number} files can be started in one batch. Split larger selections into multiple batches.",
  "service.page.bulkYaml.batchMixed": "Partially successful",
  "service.page.bulkYaml.batchPending": "Pending",
  "service.page.bulkYaml.batchSuccess": "Successful",
  "service.page.bulkYaml.batchUploading": "Uploading file {n, number}… ({done, number} started)",
  "service.page.bulkYaml.capacityRejected": "The file could not be started because all import slots were occupied. It has not been checked yet.",
  "service.page.bulkYaml.batchOpen": "Show result",
  "service.page.bulkYaml.batchHide": "Hide result",
  "service.page.bulkYaml.hideYaml": "Hide YAML",
  "service.page.bulkYaml.showYaml": "Show YAML",
  "service.page.bulkYaml.importBtnMany": "Run import for {n, number} files",
  "service.page.bulkYaml.startDryMany": "Run validation for {n, number} files",
  "service.page.bulkYaml.completedAt": "Completed {date}",
  "service.page.bulkYaml.desc": "Import a multi-document YAML payload, or drop a PDF or CV for profile extraction. The job continues when you leave this page.",
  "service.page.bulkYaml.documentsFound": "{n, plural, one {# document} other {# documents}} found",
  "service.page.bulkYaml.downloadSchema": "Download JSON schema",
  "service.page.bulkYaml.downloadYaml": "Download YAML example",
  "service.page.bulkYaml.dryRunAtomicNote": "A validation always covers the whole file at once. Single units are not isolated here.",
  "service.page.bulkYaml.dryRunNoSave": "No data was saved. The transaction was deliberately rolled back.",
  "service.page.bulkYaml.dryRunSuccessTitle": "Validation successful",
  "service.page.bulkYaml.dryRunSummary": "{n, plural, one {# row} other {# rows}} would be affected",
  "service.page.bulkYaml.extractionDone": "Extraction finished",
  "service.page.bulkYaml.extractionFailed": "Extraction failed.",
  "service.page.bulkYaml.extractionOpen": "Open result",
  "service.page.bulkYaml.extractionResultHint": "The extracted powers and skills are in your own profile.",
  "service.page.bulkYaml.extractionRunning": "Extracting powers and skills …",
  "service.page.bulkYaml.failedPartial": "Import failed. Units that had already been committed were kept.",
  "service.page.bulkYaml.forbidden": "You do not have the required permissions to import person data. This needs read:person and write:person in addition to write:reference-data.",
  "service.page.bulkYaml.formatKindLabel": "Document kind",
  "service.page.bulkYaml.formatLimits": "Format {version} · at most {docs, number} documents per file · genesis format limit {size}.",
  "service.page.bulkYaml.formatLoadFailed": "The format description could not be loaded.",
  "service.page.bulkYaml.formatLoading": "Loading format …",
  "service.page.bulkYaml.formatTitle": "Format and examples",
  "service.page.bulkYaml.formatUnavailable": "The deployed importer did not describe this kind.",
  "service.page.bulkYaml.formatUploadLimit": "Spark upload limit: {size} per file. Larger files are rejected before the import starts.",
  "service.page.bulkYaml.hint": "YAML, PDF or DOCX · each file becomes its own import job",
  "service.page.bulkYaml.importBtn": "Run import",
  "service.page.bulkYaml.indexing": "Checking the file …",
  "service.page.bulkYaml.jobIdHint": "Job ID, for support",
  "service.page.bulkYaml.leaveHint": "You may leave this page. A notification links back to this result.",
  "service.page.bulkYaml.limitsNote": "Maximum {docs, number} records per import · up to {files, number} files per batch · at most {size} per file.",
  "service.page.bulkYaml.limitsNoteSizeOnly": "Up to {files, number} files per batch · at most {size} per file.",
  "service.page.bulkYaml.modeAllOrNothing": "Abort completely",
  "service.page.bulkYaml.modeKeepSuccessful": "Keep successful",
  "service.page.bulkYaml.modeLabel": "On errors",
  "service.page.bulkYaml.newRun": "Choose another file",
  "service.page.bulkYaml.personActionsTitle": "Person changes",
  "service.page.bulkYaml.personCreate": "Create",
  "service.page.bulkYaml.personCreated": "New profile created",
  "service.page.bulkYaml.personWillBeCreated": "New profile will be created",
  "service.page.bulkYaml.personDelete": "Delete",
  "service.page.bulkYaml.personExisting": "Existing",
  "service.page.bulkYaml.personIdGenerated": "The UUID is generated during the import.",
  "service.page.bulkYaml.personIdWasGenerated": "The UUID was generated during the import.",
  "service.page.bulkYaml.personIncoming": "Import",
  "service.page.bulkYaml.personMismatchTitle": "Possibly wrong person ID",
  "service.page.bulkYaml.personRestore": "Restore",
  "service.page.bulkYaml.personRestoreResultText": "The profile was restored with the data contained in the YAML. Data not contained in the YAML was not restored.",
  "service.page.bulkYaml.personRestoreResultTitle": "Deleted profile was restored",
  "service.page.bulkYaml.personRestoreValidationText": "This UUID belongs to a deleted person. The import restores the profile data contained in the YAML. Data not contained in the YAML will not be restored.",
  "service.page.bulkYaml.personRestoreValidationTitle": "Deleted profile will be restored",
  "service.page.bulkYaml.personRowLabel": "Person {n}: {action}",
  "service.page.bulkYaml.personUpdate": "Update",
  "service.page.bulkYaml.personUpdated": "Existing profile updated",
  "service.page.bulkYaml.personWillBeUpdated": "Existing profile will be updated",
  "service.page.bulkYaml.personRestored": "Deleted profile restored",
  "service.page.bulkYaml.personDeleted": "Profile deleted",
  "service.page.bulkYaml.pipelineLabel": "Import steps",
  "service.page.bulkYaml.progress": "{done} of {total} documents processed{kind, select, none {} other { · {kind}}}",
  "service.page.bulkYaml.queued": "Waiting for processing",
  "service.page.bulkYaml.rejectedTooLarge": "Too large (over {max} per file): {names}",
  "service.page.bulkYaml.rejectedType": "Unsupported file type ({names}). Use .yaml or .yml.",
  "service.page.bulkYaml.retryBtn": "Fix file and retry",
  "service.page.bulkYaml.retryFile": "Retry",
  "service.page.bulkYaml.retrying": "Retrying …",
  "service.page.bulkYaml.problemDependency": "This document was skipped because a referenced document failed.",
  "service.page.bulkYaml.problemDependencyFix": "Fix the first failed document. This dependent document can then be imported automatically.",
  "service.page.bulkYaml.problemDocumentation": "Open format and example documentation ↓",
  "service.page.bulkYaml.problemDuplicate": "The ID or another unique value already exists.",
  "service.page.bulkYaml.problemDuplicateFix": "Use merge to update it. To create a new entry, omit the document's content.id or assign a new one.",
  "service.page.bulkYaml.problemFix": "How to fix it",
  "service.page.bulkYaml.problemInvalidFormat": "The YAML syntax or document structure is invalid.",
  "service.page.bulkYaml.problemInvalidFormatFix": "Check indentation, the document envelope, value types, and required blocks against an example.",
  "service.page.bulkYaml.problemInvalidReference": "A referenced entry cannot be found.",
  "service.page.bulkYaml.problemInvalidReferenceValue": "The referenced entry “{value}” cannot be found.",
  "service.page.bulkYaml.problemInvalidReferenceFix": "Use the UUID of an existing entry, or reference a document in this file through its metadata.name.",
  "service.page.bulkYaml.problemInvalidValue": "The value “{value}” is invalid.",
  "service.page.bulkYaml.problemInvalidValueFix": "Use the documented type, spelling, and permitted value range.",
  "service.page.bulkYaml.problemInvalidValueGeneric": "A value is missing, invalid, or outside the permitted range.",
  "service.page.bulkYaml.problemInvalidValueSuggestion": "Use “{value}” instead.",
  "service.page.bulkYaml.problemLocation": "Near line {line}",
  "service.page.bulkYaml.problemLocationColumn": "Near line {line}, column {column}",
  "service.page.bulkYaml.problemMissing": "The required field “{field}” is missing.",
  "service.page.bulkYaml.problemMissingAlternative": "At least one of these fields is required: {expected}.",
  "service.page.bulkYaml.problemMissingAlternativeFix": "Add at least one of the listed fields with a non-empty value.",
  "service.page.bulkYaml.problemMissingFix": "Add the field with a value of the type shown in the format documentation.",
  "service.page.bulkYaml.problemPersistence": "The database could not store this otherwise valid document.",
  "service.page.bulkYaml.problemPersistenceFix": "Retry once. If it fails again, give support the job ID shown above.",
  "service.page.bulkYaml.problemUnexpected": "The import failed for an unexpected technical reason.",
  "service.page.bulkYaml.problemUnexpectedFix": "Retry once. If it fails again, give support the job ID shown above.",
  "service.page.bulkYaml.problemUnknown": "The field “{field}” is not supported here.",
  "service.page.bulkYaml.problemUnknownField": "a required field",
  "service.page.bulkYaml.problemUnknownFix": "Rename or remove the field and compare the document with the format example.",
  "service.page.bulkYaml.problemUnknownFixExpected": "Rename or remove it. Supported fields include: {expected}.",
  "service.page.bulkYaml.problemUnsupported": "This operation or field change is not supported for this document kind.",
  "service.page.bulkYaml.problemUnsupportedFix": "Use one of the operations listed for this kind and leave immutable fields unchanged.",
  "service.page.bulkYaml.problemWhat": "What is wrong",
  "service.page.bulkYaml.rolledBack": "Import failed; all database changes were rolled back.",
  "service.page.bulkYaml.routeExtraction": "CV and PDF extraction",
  "service.page.bulkYaml.routeYaml": "YAML import",
  "service.page.bulkYaml.routingHint": "PDF and DOCX files go to CV extraction. Validation and partial import are YAML only.",
  "service.page.bulkYaml.runBadgeDry": "Validation · {mode}",
  "service.page.bulkYaml.runBadgeReal": "Import · {mode}",
  "service.page.bulkYaml.stageFile": "File",
  "service.page.bulkYaml.stageImport": "Import",
  "service.page.bulkYaml.stageQueue": "Queue",
  "service.page.bulkYaml.stageResult": "Result",
  "service.page.bulkYaml.startDry": "Run validation",
  "service.page.bulkYaml.starting": "Starting …",
  "service.page.bulkYaml.stepStateActive": "in progress",
  "service.page.bulkYaml.stepStateDone": "done",
  "service.page.bulkYaml.stepStateFailed": "failed",
  "service.page.bulkYaml.stepStatePending": "not started yet",
  "service.page.bulkYaml.successTitle": "Import successful",
  "service.page.bulkYaml.summary": "{n, plural, one {# row} other {# rows}} affected",
  "service.page.bulkYaml.title": "File import",
  "service.page.bulkYaml.unitDeleteAria": "Delete {id}",
  "service.page.bulkYaml.unitDeletePersonMessage": "“{id}” will be deleted permanently, including all profile data. This removes the whole person, not just the imported changes.",
  "service.page.bulkYaml.unitDeletePersonTitle": "Delete person?",
  "service.page.bulkYaml.unitDeleteSharedItemMessage": "“{id}” will be deleted permanently, including all comments. This removes the whole post, not just the imported changes.",
  "service.page.bulkYaml.unitDeleteSharedItemTitle": "Delete post?",
  "service.page.bulkYaml.unitDeleted": "Deleted",
  "service.page.bulkYaml.unitTechnicalId": "Technical ID",
  "service.page.bulkYaml.unitTechnicalIdAria": "Show technical ID for {label}",
  "service.page.bulkYaml.unitDependencyFailed": "Not attempted, because a unit it depends on did not succeed.",
  "service.page.bulkYaml.unitDuplicate": "This entry already exists. Use “merge” instead of “insert” to update it, or remove it first.",
  "service.page.bulkYaml.unitInvalidInput": "The document was rejected: invalid or missing values.",
  "service.page.bulkYaml.unitInvalidReference": "A reference in the document does not exist.",
  "service.page.bulkYaml.unitPersistenceError": "The database refused this write.",
  "service.page.bulkYaml.unitUnexpectedError": "Unexpected error while importing this unit.",
  "service.page.bulkYaml.unitsFailed": "{n} failed",
  "service.page.bulkYaml.unitsFailedGroup": "Failed units",
  "service.page.bulkYaml.unitsSkipped": "{n} skipped",
  "service.page.bulkYaml.unitsSkippedGroup": "Skipped units",
  "service.page.bulkYaml.unitsSucceeded": "{n} succeeded",
  "service.page.bulkYaml.unitsSucceededGroup": "Succeeded units",
  "service.page.bulkYaml.warningBlobCleanup": "{n, plural, one {# uploaded file could not be removed again and remains stored.} other {# uploaded files could not be removed again and remain stored.}}",
  "service.page.bulkYaml.warningBlobCleanupHint": "An operator can remove them by hand using these storage ids.",
  "service.page.bulkYaml.zone": "Drag YAML, PDF or CV files here or click to add",
  "service.page.cardYamlExportDesc": "Exports your entire profile including photos and documents as a YAML file that can be imported again.",
  "service.page.cardYamlExportTitle": "Profile export",
  "service.yamlExport.documents": "Documents",
  "service.yamlExport.documentsDesc": "Document folders and files, including metadata, tags and file content. Without Profile, the person must already exist when importing.",
  "service.yamlExport.download": "Download YAML",
  "service.yamlExport.exporting": "Exporting…",
  "service.yamlExport.intro": "Choose which areas to include in the export. You can import the downloaded file again with the YAML importer.",
  "service.yamlExport.profile": "Profile",
  "service.yamlExport.profileDesc": "Personal details, portraits, experience, education, expertise, languages and certificates",
  "service.yamlExport.selectionRequired": "Select at least one area.",
  "service.yamlExport.title": "YAML export",
  "admin.groupLimitReached": "You have reached the maximum of {limit} groups.",
  "admin.groupSaveFailed": "The group could not be saved.",
  "service.page.bulkYaml.personMismatchText": "Name and primary e-mail both differ from the stored person. The import updates the existing person with this UUID.",
  "service.page.bulkYaml.personMismatchNotice": "{n, plural, one {Running the import updates the existing person with this UUID. If that is not intended, correct the UUID in the file first.} other {Running the import updates the existing persons with these UUIDs. If that is not intended, correct the UUIDs in the file first.}}",
  "service.page.bulkYaml.personRestoreNotice": "{n, plural, one {Running the import restores this deleted profile. If that is not intended, remove the UUID from the file first.} other {Running the import restores these deleted profiles. If that is not intended, remove the UUIDs from the file first.}}",
  "service.page.bulkYaml.personRiskNotice": "Running the import applies the shown updates and restores the deleted profiles. If that is not intended, correct the UUIDs in the file first.",
  "match.result.requirementDiagram.axisFulfilled": "Fulfilled ↑",
  "match.result.requirementDiagram.axisUnfulfilled": "Not fulfilled ↓",
  "match.result.requirementDiagram.ruleAll": "all",
  "match.result.requirementDiagram.ruleAny": "at least 1",
  "match.result.requirementDiagram.ruleMin": "at least {n}",
  "match.result.requirementDiagram.ruleMinUnknown": "at least ?",
  "match.result.requirementDiagram.ruleMax": "at most {n}",
  "match.result.requirementDiagram.ruleMaxUnknown": "at most ?",
  "match.result.requirementDiagram.ruleExact": "exactly {n}",
  "match.result.requirementDiagram.ruleExactUnknown": "exactly ?",
  "match.result.requirementDiagram.personLevel": "Level: {level}",
  "match.result.requirementDiagram.closeLabel": "Close",
  "match.result.requirementDiagram.noContributors": "Nobody on the team carries this.",
  "company.admin.logo.changeHover": "Change logo",
  "organizationalRecord.heading": "Organisational record",
  "organizationalRecord.description": "Internal documents and discussions about this person.",
  "organizationalRecord.documents": "Documents",
  "organizationalRecord.entries": "Notes & reports",
  "organizationalRecord.discussion": "General discussion",
  "organizationalRecord.noAccess": "This area requires the organisation Manager/HR role.",
  "organizationalRecord.backToProfile": "Back to profile",
  "organizationalRecord.empty": "No organisational record has been created for this person yet.",
  "organizationalRecord.create": "Create organisational record",
  "organizationalRecord.newEntry": "Add note / report",
  "organizationalRecord.editEntry": "Edit entry",
  "organizationalRecord.note": "Note",
  "organizationalRecord.report": "Report",
  "organizationalRecord.kind": "Type",
  "organizationalRecord.titleField": "Title",
  "organizationalRecord.contentField": "Content",
  "organizationalRecord.noEntries": "No notes or reports yet.",
  "organizationalRecord.updated": "Edited by {name} on {date}",
  "organizationalRecord.deleteEntry": "Delete entry?",
  "organizationalRecord.deleteEntryHelp": "Comments on this entry will also be deleted.",
  "organizationalRecord.upload": "Upload document",
  "organizationalRecord.uploadHelp": "PDF, Office, text or images · up to 10 MB per file",
  "organizationalRecord.uploadRejected": "Choose a supported, non-empty file of up to 10 MB.",
  "organizationalRecord.noDocuments": "No documents yet.",
  "organizationalRecord.preview": "Preview",
  "organizationalRecord.download": "Download",
  "organizationalRecord.rename": "Rename",
  "organizationalRecord.deleteDocument": "Delete document?",
  "organizationalRecord.documentsHint": "Documents in this person's organisational record.",
  "organizationalRecord.links.label": "Linked",
  "organizationalRecord.links.add": "Link {title} ({kind})",
  "organizationalRecord.links.select": "Link a document or entry",
  "organizationalRecord.links.remove": "Remove link to {title}",
  "organizationalRecord.links.search": "Find documents and entries in this organisational record …",
  "organizationalRecord.links.noMatches": "No matching documents or entries.",
  "organizationalRecord.links.usedIn": "Used in",
  "organizationalRecord.links.comment": "Discussion comment",
  "organizationalRecord.links.unused": "No references to this content yet.",
  "organizationalRecord.links.details": "Details & links",
  "organizationalRecord.links.unavailable": "This content is no longer available in this organisational record.",
  "organizationalRecord.links.downloaded": "The file was downloaded because this format does not support previews.",
  "organizationalRecord.drafts.invalid": "Complete the title and content of your notes or reports, and check the text length. Comments require text (up to 4,096 characters); notes and reports allow 255 characters in the title and 65,535 in the content.",
  "organizationalRecord.drafts.discardEntry": "Discard the unsaved changes to this note or report, including its links?",
  "organizationalRecord.comments.newest": "Newest first",
  "organizationalRecord.comments.oldest": "Oldest first"
}
